{
	"dialog.ok": "OK",
	"dialog.cancel": "Annuleren",
	"dialog.confirm": "Bevestig",
	"dialog.close": "Sluit",
	"dialog.import": "Importeer",
	"dialog.save": "Opslaan",
	"dialog.discard": "Weggooien",
	"dialog.dontshowagain": "Niet Opnieuw Laten Zien",
	"data.cube": "Kubus",
	"data.group": "Groep",
	"data.texture": "Textuur",
	"data.plugin": "Plugin",
	"data.preview": "Voorvertoning",
	"data.toolbar": "Gereedschapsbalk",
	"data.image": "Afbeelding",
	"keys.ctrl": "Control",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Verwijderen",
	"keys.space": "Space",
	"keys.leftclick": "Linker muisknop",
	"keys.middleclick": "Midden muisknop",
	"keys.rightclick": "Rechter muisknop",
	"keys.tab": "Tab",
	"keys.backspace": "Backspace",
	"keys.enter": "Enter",
	"keys.escape": "Escape",
	"keys.function": "F%0",
	"keys.numpad": "Numpad %0",
	"keys.caps": "Capslock",
	"keys.menu": "Textmenu",
	"keys.left": "Links",
	"keys.up": "Omhoog",
	"keys.right": "Rechts",
	"keys.down": "Omlaag",
	"keys.pageup": "Page Up",
	"keys.pagedown": "Page Down",
	"keys.plus": "Plus",
	"keys.comma": "Komma",
	"keys.point": "Punt",
	"keys.minus": "Min",
	"keys.cross": "Plus",
	"keys.end": "Einde",
	"keys.pos1": "Pos 1",
	"keys.printscreen": "Schermafbeelding",
	"keys.pause": "Pauzeer",
	"message.rotation_limit.title": "Rotatie Limiet",
	"message.rotation_limit.message": "Rotaties zijn door Minecraft over één as tegelijkertijd en stappen van 22,5 graad gelimiteerd. Roteren op een andere as zal de rotaties op overige assen verwijderen. Je kan je model converteren naar een \"vrije model\" als je voor een andere reden aan het moddelen bent en vrije rotatie nodig hebt.",
	"message.file_not_found.title": "Bestand Niet Gevonden",
	"message.file_not_found.message": "Blockbench kon het gekozen bestand niet vinden. Zorg ervoor dat het lokaal opgeslagen is en niet in de cloud.",
	"message.screenshot.title": "Schermafbeelding",
	"message.screenshot.clipboard": "Klembord",
	"message.screenshot.right_click": "Schermafbeelding - Rechtermuisklik om te kopiëren",
	"message.invalid_file.title": "Ongeldig Bestand",
	"message.invalid_file.message": "Kon model bestand %0 niet openen",
	"message.invalid_model.title": "Onjuist Model Bestand",
	"message.invalid_model.message": "Dit bestand bevat geen juiste data voor een model",
	"message.child_model_only.title": "Leeg Kind Element",
	"message.child_model_only.message": "Dit bestand is een kind van %0 en bevat geen model",
	"message.unsaved_textures.title": "Niet-opgeslagen Texturen",
	"message.unsaved_textures.message": "Je model heeft niet-opgeslagen texturen. Zorg ervoor dat ze opgeslagen zijn en plaats ze in de juiste map in je resource pack.",
	"message.model_clipping.title": "Model Te Groot",
	"message.model_clipping.message": "Je model bevat %0 kubussen die groter zijn dan het toegestane 3x3x3 limiet in Minecraft. Dit model zal niet werken in Minecraft.",
	"message.loose_texture.title": "Textuur Import",
	"message.loose_texture.message": "De geïmporteerde textuur zit niet in een resource pack. Minecraft kan alleen texturen laden uit de textuur map van een geladen resource pack.",
	"message.loose_texture.change": "Bestandsroute Veranderen",
	"message.update_res.title": "Textuur Resolutie",
	"message.update_res.message": "Wil je de resolutie van het project veranderen naar de resolutie van deze textuur? Klik 'Terug' als je afbeelding een grotere resolutie heeft dan normaal.",
	"message.update_res.update": "Update",
	"message.bedrock_overwrite_error.message": "Blockbench kan dit model niet combineren met het oude bestand",
	"message.bedrock_overwrite_error.backup_overwrite": "Maak een Backup en overschrijf",
	"message.bedrock_overwrite_error.overwrite": "Overschrijven",
	"message.close_warning.message": "Wil je je model opslaan?",
	"message.close_warning.web": "Je huidige werk zal verloren gaan. Weet je zeker dat je wilt afsluiten?",
	"message.default_textures.title": "Standaard Texturen",
	"message.default_textures.message": "Selecteer de \"textures\"-map van het standaard resource pack",
	"message.default_textures.detail": "Pak de standaard resource pack van de Minecraft jar uit of google en download het. Zoek de \"textures\"-map en open hem. Blockbench zal de locatie onthouden en daar afbeeldingen uit halen als ze niet in de huidige resource pack te vinden zijn.",
	"message.default_textures.select": "Selecteer de standaard \"textures\"-map",
	"message.image_editor.title": "Selecteer een afbeelding-bewerker",
	"message.image_editor.file": "Selecteer Bestand...",
	"message.image_editor.exe": "Selecteer een foto-bewerker uitvoerbaar bestand",
	"message.display_skin.title": "Minecraft Skin",
	"message.display_skin.message": "Selecteer een skin bestand van je computer of vul een spelernaam in",
	"message.display_skin.upload": "Selecteer Bestand",
	"message.display_skin.reset": "Herstel",
	"message.invalid_plugin": "Onjuist Plugin Bestand, Zie Console",
	"message.load_plugin_app": "Wil je toestaan dat deze plugin verandering aanbrengt aan je PC? Laad alleen plugins van mensen die je vertrouwt.",
	"message.load_plugin_web": "Wil je deze plugin laden? Laad alleen plugins van mensen die je vertrouwt.",
	"message.preset_no_info": "Preset bevat geen informatie voor dit slot",
	"message.restart_to_update": "Herstart Blockbench om wijzigingen aan te brengen",
	"message.save_file": "Opgeslagen als %0",
	"dialog.project.title": "Project",
	"dialog.project.name": "Bestandsnaam",
	"dialog.project.parent": "Ouder model",
	"dialog.project.geoname": "Mob Geometrie Naam",
	"dialog.project.ao": "Ambient Occlusion",
	"dialog.texture.title": "Textuur",
	"dialog.texture.variable": "Variabele",
	"dialog.texture.namespace": "Naamruimte",
	"dialog.texture.folder": "Map",
	"dialog.extrude.title": "Beeld Extruderen",
	"dialog.extrude.mode": "Scanmodus",
	"dialog.extrude.mode.areas": "Gebieden",
	"dialog.extrude.mode.lines": "Lijnen",
	"dialog.extrude.mode.columns": "Kolommen",
	"dialog.extrude.mode.pixels": "Pixels",
	"dialog.extrude.opacity": "Minimum Ondoorzichtigheid",
	"dialog.extrude.scan": "Scan en Importeer",
	"dialog.display_preset.title": "Maak Preset",
	"dialog.display_preset.message": "Selecteer de slots die je wilt opslaan",
	"dialog.display_preset.create": "Maak",
	"dialog.select.title": "Selecteer",
	"dialog.select.group": "In Geselecteerde Groep",
	"dialog.select.name": "Naam Bevat",
	"dialog.select.random": "Willekeurig (%)",
	"dialog.select.select": "Selecteer",
	"dialog.scale.title": "Schaal Model",
	"dialog.scale.axis": "As",
	"dialog.scale.clipping": "Model clipping: Je model is te groot voor het canvas",
	"dialog.scale.confirm": "Herschaal",
	"dialog.plugins.title": "Plugins",
	"dialog.plugins.installed": "Geïnstalleerd",
	"dialog.plugins.available": "Beschikbaar",
	"dialog.plugins.install": "Installeer",
	"dialog.plugins.uninstall": "de-installeren",
	"dialog.plugins.reload": "Herlaad",
	"dialog.plugins.none_installed": "Geen plugins geïnstalleerd",
	"dialog.plugins.none_available": "Geen plugins beschikbaar",
	"dialog.plugins.web_only": "Alleen voor de web app",
	"dialog.plugins.app_only": "Alleen voor de desktop app",
	"dialog.plugins.author": "door %0",
	"dialog.create_texture.folder": "Map",
	"dialog.create_texture.resolution": "Resolutie",
	"dialog.input.title": "Invoer",
	"dialog.settings.settings": "Instellingen",
	"dialog.settings.keybinds": "Sneltoetsen",
	"dialog.settings.about": "Over",
	"layout.color.back": "Terug",
	"layout.color.back.desc": "Achtergronden en invoervelden",
	"layout.color.dark": "Donker",
	"layout.color.dark.desc": "Canvas achtergrond",
	"layout.color.ui": "UI",
	"layout.color.ui.desc": "Hoofdinterface kleur",
	"layout.color.bright_ui": "Helder UI",
	"layout.color.bright_ui.desc": "Context menu's en tooltips",
	"layout.color.button": "Knop",
	"layout.color.button.desc": "Knoppen en Schakelaars",
	"layout.color.selected": "Geselecteerd",
	"layout.color.selected.desc": "Geselecteerde tabladen en objecten",
	"layout.color.border": "Rand",
	"layout.color.border.desc": "Rand van knoppen en invoer",
	"layout.color.accent": "Accent",
	"layout.color.accent.desc": "Schuifknop en andere details",
	"layout.color.grid": "Rooster",
	"layout.color.grid.desc": "3D voorvertooning rooster",
	"layout.color.text": "Tekst",
	"layout.color.text.desc": "Normale tekst",
	"layout.color.light": "Licht",
	"layout.color.light.desc": "Geselecteerde tekst",
	"layout.color.accent_text": "Accent Tekst",
	"layout.color.accent_text.desc": "Tekst op accent elementen",
	"layout.font.main": "Hoofd lettertype",
	"layout.font.headline": "Opschriftlettertype",
	"about.version": "Versie:",
	"settings.category.general": "Algemeen:",
	"settings.category.preview": "Voorvertooning",
	"settings.category.grid": "Rooster",
	"settings.category.edit": "Wijzigen",
	"settings.category.snapping": "Snapping",
	"settings.category.defaults": "Standaard",
	"settings.category.dialogs": "Dialogen",
	"settings.category.export": "Exporteren",
	"settings.language": "Taal",
	"settings.language.desc": "Interface taal. Herstart Blockbench om wijzigingen aan te brengen",
	"settings.backup_interval": "Backup Frequentie",
	"settings.backup_interval.desc": "Frequentie van de automatische backups in minuten",
	"settings.origin_size": "Draaipunt Markeerder",
	"settings.origin_size.desc": "Grootte van  rotatie draaipunt markeerder",
	"settings.control_size": "As Controle Grootte",
	"settings.control_size.desc": "Grootte van de 3 assen controle gereedschap",
	"settings.display_skin": "Toon Skin",
	"settings.display_skin.desc": "Skin gebruikt voor het referentie speler model",
	"settings.shading": "Shading",
	"settings.shading.desc": "Gebruik shading",
	"settings.base_grid": "Klein Rooster",
	"settings.base_grid.desc": "Toon klein grid en assen",
	"settings.large_grid": "Blokrooster",
	"settings.large_grid.desc": "Toon 3x3 blok rooster",
	"settings.full_grid": "Volledig Blokrooster",
	"settings.full_grid.desc": "Toon pixel-precies blokrooster",
	"settings.large_box": "Groottelimiet Box",
	"settings.large_box.desc": "Toon groottelimiet grenzen",
	"settings.display_grid": "Weergavemodus",
	"settings.display_grid.desc": "Toon rooster in weergavemodus",
	"settings.undo_limit": "Ongedaan maken Limiet",
	"settings.undo_limit.desc": "Aantal stappen dat je ongedaan kan maken",
	"settings.local_move": "Beweeg op Relatieve Assen",
	"settings.local_move.desc": "Beweeg gedraaide elementen op hun eigen assen indien mogelijk",
	"settings.canvas_unselect": "Canvas Klik Deselecteer",
	"settings.canvas_unselect.desc": "Deselecteerd alle elementen wanneer er op de canvas achtergrond wordt geklikt",
	"settings.paint_side_restrict": "Beperk Kwast tot Vlak",
	"settings.paint_side_restrict.desc": "Beperk Kwast om enkel op het huidige vlak te tekenen",
	"settings.autouv": "Auto UV",
	"settings.autouv.desc": "Pas Auto UV standaard toe",
	"settings.create_rename": "Geef Nieuwe Kubus Een Naam",
	"settings.create_rename.desc": "Focus naam veld bij het creëren van een nieuw element of groep",
	"settings.edit_size": "Rooster Resolutie",
	"settings.edit_size.desc": "Resolutie van het rooster waar kubussen naartoe snappen",
	"settings.shift_size": "Shift Resolutie",
	"settings.shift_size.desc": "Resolutie van het rooster waneer je shift inhoudt",
	"settings.ctrl_size": "Control Resolutie",
	"settings.ctrl_size.desc": "Resolutie van het rooster waneer je control inhoudt",
	"settings.negative_size": "Negatieve Grootte",
	"settings.negative_size.desc": "Toestaan om negatieve grootte te gebruiken",
	"settings.minifiedout": "Geminimaliseerde Export",
	"settings.minifiedout.desc": "Schrijf JSON bestand op een lijn",
	"settings.export_groups": "Exporteer Groepen",
	"settings.export_groups.desc": "Sla groepen op in blokmodel bestanden",
	"settings.credit": "Credit Opmerking",
	"settings.credit.desc": "Voeg een credit opmerking toe aan geëxporteerde bestanden",
	"settings.default_path": "Standaard Minecraft Texturen Pad",
	"settings.default_path.desc": "Map waarvan Blockbench de standaard texturen laadt",
	"settings.image_editor": "Afbeelding Bewerker",
	"settings.image_editor.desc": "Standaard afbeelding verwerker om textures mee te bewerken",
	"category.navigate": "Navigatie",
	"category.tools": "Gereedschap",
	"category.file": "Bestand",
	"category.blockbench": "Blockbench",
	"category.edit": "Bewerk",
	"category.transform": "Transformeren",
	"category.view": "Bekijken",
	"category.display": "Tentoonstel instellingen",
	"category.textures": "Texturen",
	"category.misc": "Overig",
	"keybind.preview_select": "Selecteer",
	"keybind.preview_rotate": "Beeld draaien",
	"keybind.preview_drag": "Zicht verplaatsen",
	"keybind.confirm": "Bevestig",
	"keybind.cancel": "Annuleer",
	"action.slider_inflate": "Opblazen",
	"action.slider_inflate.desc": "Kubussen alle kanten op opblazen zonder de UV te veranderen",
	"action.slider_brush_size": "Grootte",
	"action.slider_brush_size.desc": "Straal van de kwast in pixels",
	"action.slider_brush_opacity": "Doorzichtigheid",
	"action.slider_brush_opacity.desc": "Doorzichtigheid van de kwast van 0 tot 255",
	"action.slider_brush_softness": "Zachtheid",
	"action.slider_brush_softness.desc": "Zacheid van de kwast in %",
	"action.uv_slider_pos_x": "Beweeg Horizontaal",
	"action.uv_slider_pos_x.desc": "Verplaats alle geselecteerde UV vlakken horizontaal",
	"action.uv_slider_pos_y": "Beweeg Verticaal",
	"action.uv_slider_pos_y.desc": "Verplaats alle geselecteerde UV vlakken verticaal",
	"action.uv_slider_size_x": "Herschaal Horizontaal",
	"action.uv_slider_size_x.desc": "Herschaal alle geselecteerde UV vlakken horizontaal",
	"action.uv_slider_size_y": "Herschaal Verticaal",
	"action.uv_slider_size_y.desc": "Herschaal alle geselecteerde UV vlakken verticaal",
	"action.vertex_snap_mode": "Snap Mode",
	"action.vertex_snap_mode.desc": "Selecteer of Vertex Snap elementen verplaatst of herschaalt naar de geselecteerde positie",
	"action.move_tool": "Verplaatsen",
	"action.move_tool.desc": "Gereedschap om elementen te selecteren en te verplaatsen",
	"action.resize_tool": "Formaat veranderen",
	"action.resize_tool.desc": "Gereedschap om elementen te selecteren en te vergrootten",
	"action.brush_tool": "Verfkwast",
	"action.brush_tool.desc": "Gereedschap om te tekenen op texturen",
	"action.vertex_snap_tool": "Vertex Snap",
	"action.vertex_snap_tool.desc": "Beweeg een kubus naar een ander kubus door twee hoeken te verbinden",
	"action.swap_tools": "Verwissel Gereedschap",
	"action.swap_tools.desc": "Verwissel verplaats en vergroot gereedschap",
	"action.project_window": "Project...",
	"action.project_window.desc": "Opend het project scherm, waar de metadata van je model kan wijzigen",
	"action.open_model": "Open Model",
	"action.open_model.desc": "Open een model bestand op je computer",
	"action.extrude_texture": "Geëxtrudeerde textuur",
	"action.extrude_texture.desc": "Genereer een model door een textuur uit te rekken",
	"action.export_blockmodel": "Exporteer Blockmodel",
	"action.export_blockmodel.desc": "Exporteer Minecraft blok of item model",
	"action.export_optifine_part": "Exporteer OptiFine JPM",
	"action.export_optifine_part.desc": "Exporteer een entity deel model voor OptiFine",
	"action.export_optifine_full": "Exporteer OptiFine JEM",
	"action.export_optifine_full.desc": "Exporteer een volledig OptiFine entity model",
	"action.export_obj": "Exporteer OBJ Model",
	"action.export_obj.desc": "Exporteer een Wavefront OBJ model voor rendering",
	"action.settings_window": "Instellingen...",
	"action.settings_window.desc": "Open het Blockbench instellingen venster",
	"action.plugins_window": "Plugins...",
	"action.plugins_window.desc": "Open het plugin venster",
	"action.reset_layout": "Herstel Lay-out",
	"action.reset_layout.desc": "Herstel de lay-out naar Blockbench's standaard",
	"action.load_plugin": "Laad Plugin uit Bestand",
	"action.load_plugin.desc": "Laad een plugin door het bronbestand te importeren",
	"action.reload_plugins": "Herlaad Plugins",
	"action.reload_plugins.desc": "Herlaadt alle development plugins.",
	"action.undo": "Ongedaan Maken",
	"action.undo.desc": "Maakt de laatste verandering ongedaan",
	"action.redo": "Herhalen",
	"action.redo.desc": "Herhaalt de laatste ongedaanmaking",
	"action.copy": "Kopiëren",
	"action.copy.desc": "Kopieer de geselecteerde selectie, vlak of weergave-instelling",
	"action.paste": "Plakken",
	"action.paste.desc": "Plak de geselecteerde selectie, vlak of weergave-instelling",
	"action.cut": "Knippen",
	"action.cut.desc": "Knip de geselecteerde selectie, vlak of weergave-instelling",
	"action.add_cube": "Voeg Kubus Toe",
	"action.add_cube.desc": "Voegt een nieuwe kubus toe",
	"action.add_group": "Nieuwe Groep",
	"action.add_group.desc": "Voegt een nieuwe groep of been toe",
	"action.outliner_toggle": "Meer Opties",
	"action.outliner_toggle.desc": "Zet knoppen voor meer opties in de omlijner aan/uit",
	"action.duplicate": "Dupliceren",
	"action.delete": "Verwijderen",
	"action.sort_outliner": "Omlijning Sorteren",
	"action.sort_outliner.desc": "Sorteer de omlijning alfabetisch",
	"action.select_window": "Selecteer...",
	"action.select_window.desc": "Zoek en selecteer kubussen op basis van hun eigenschappen",
	"action.invert_selection": "Selectie Omkeren",
	"action.invert_selection.desc": "Keer de selectie van kubussen om",
	"action.select_all": "Alles Selecteren",
	"action.collapse_groups": "Groepen Samenvouwen",
	"action.collapse_groups.desc": "Vouw alle groepen in de omlijning samen",
	"action.scale": "Schalen...",
	"action.scale.desc": "Schaal de geselecteerde kubussen",
	"action.toggle_visibility": "Zet Zichtbaarheid Aan/Uit",
	"action.toggle_visibility.desc": "Zet de zichtbaarheid van de geselecteerde kubussen aan/uit",
	"action.toggle_export": "Zet Export Aan/Uit",
	"action.toggle_export.desc": "Zet de expoteer instellingen van de geselecteerde kubusen aan/uit.",
	"action.toggle_autouv": "Zet Auto UV Aan/Uit",
	"action.toggle_autouv.desc": "Zet de auto UV setting van de geselecteerde kubusen aan/uit.",
	"action.toggle_shade": "Zet Shading Aan/Uit",
	"action.toggle_shade.desc": "Zet de shading van de geselecteerde kubussen aan/uit.",
	"action.rename": "Een Andere Naam Geven",
	"action.rename.desc": "Wijzig de naam van de geselecteerde kubussen",
	"action.add_display_preset": "Nieuwe Preset",
	"action.add_display_preset.desc": "Voeg een nieuwe weergave preset toe",
	"action.fullscreen": "Volledig Scherm",
	"action.fullscreen.desc": "Zet volledig scherm modus aan/uit.",
	"action.zoom_in": "Zoom In",
	"action.zoom_in.desc": "Zoom in om de interface te vergrootten",
	"action.zoom_out": "Zoom Uit",
	"action.zoom_out.desc": "Zoom uit om de interface the verkleinen",
	"action.zoom_reset": "Herstel Zoom",
	"action.zoom_reset.desc": "Herstel zoom tot de standaard 100%",
	"action.reset_interface": "Herstel Interface",
	"action.reset_interface.desc": "Herstel grootte en positie van de GUI",
	"action.screenshot_model": "Screenshot Model",
	"action.screenshot_model.desc": "Neem een screenshot van het model vanuit het huidige standpunt",
	"action.screenshot_app": "Screenshot App",
	"action.screenshot_app.desc": "Neem een screenshot van de hele applicatie",
	"action.import_texture": "Textuur Importeren",
	"action.import_texture.desc": "Importeer een of meerdere texturen van je bestandssysteem",
	"action.create_texture": "Maak Textuur Aan",
	"action.create_texture.desc": "Maak een nieuwe textuur of sjabloon aan",
	"action.save_textures": "Texturen Opslaan",
	"action.save_textures.desc": "Sla alle niet-opgeslagen texturen op",
	"action.animated_textures": "Start Geanimeerde Texturen",
	"action.animated_textures.desc": "Start en pauzeer de weergave van geanimeerde texturen",
	"action.origin_to_geometry": "Centreer Draaipunt",
	"action.origin_to_geometry.desc": "Zet het draaipunt naar het midden van de geometrie",
	"action.bone_reset_toggle": "Herstel bot",
	"action.bone_reset_toggle.desc": "Stop het bot van de kubussen van de ouder te laten zien ",
	"action.reload": "Herlaad Blockbench",
	"action.reload.desc": "Herstart Blockbench. Alle niet-opgeslagen veranderingen zullen verloren gaan.",
	"menu.file": "Bestand",
	"menu.edit": "Bewerken",
	"menu.transform": "Transformeren",
	"menu.display": "Weergave",
	"menu.view": "Beeld",
	"menu.file.new": "Nieuw",
	"menu.file.recent": "Recente",
	"menu.file.import": "Importeren",
	"menu.file.export": "Exporteren",
	"menu.transform.rotate": "Draaien",
	"menu.transform.flip": "Omdraaien",
	"menu.transform.center": "Centreren",
	"menu.transform.properties": "Eigenschappen",
	"menu.display.preset": "Pas Preset Toe",
	"menu.display.preset_all": "Pas Preset Overal Toe",
	"menu.display.remove_preset": "Verwijder Preset",
	"menu.view.zoom": "Zoom",
	"menu.view.background": "Achtergrond",
	"menu.view.screenshot": "Schermafbeelding",
	"menu.cube.color": "Markeerkleur",
	"menu.cube.texture": "Afbeelding",
	"menu.cube.texture.transparent": "Transparant",
	"menu.cube.texture.blank": "Leeg",
	"menu.group.sort": "Sorteren",
	"menu.texture.face": "Pas Toe op Vlak",
	"menu.texture.file": "Bestand",
	"menu.texture.refresh": "Ververs",
	"menu.texture.change": "Wijzig Bestand",
	"menu.texture.folder": "Open in Map",
	"menu.texture.edit": "Wijzigen",
	"menu.texture.export": "Opslaan Als",
	"menu.texture.save": "Opslaan",
	"menu.texture.properties": "Eigenschappen",
	"menu.preview.background": "Achtergrond",
	"menu.preview.background.load": "Laden",
	"menu.preview.background.position": "Positie",
	"menu.preview.background.lock": "Vastzetten Op De Camera",
	"menu.preview.screenshot": "Schermafbeelding",
	"menu.preview.perspective": "Perspectief",
	"menu.preview.perspective.normal": "Normaal",
	"menu.preview.quadview": "Vierdelige Weergave",
	"menu.preview.stop_drag": "Stop Achtergrong Positionering",
	"menu.uv.mapping.rotation": "Rotatie",
	"menu.uv.texture": "Afbeelding",
	"cube.color.light_blue": "Lichtblauw",
	"cube.color.yellow": "Geel",
	"cube.color.orange": "Oranje",
	"cube.color.red": "Rood",
	"cube.color.purple": "Paars",
	"cube.color.blue": "Blauw",
	"cube.color.green": "Groen",
	"cube.color.lime": "Lichtgroen",
	"switches.visibility": "Zichtbaarheid",
	"switches.export": "Exporteer",
	"switches.autouv": "Auto UV",
	"panel.uv": "UV",
	"panel.display": "Toning",
	"panel.textures": "Afbeeldingen",
	"panel.outliner": "Omlijning",
	"uv_editor.title": "UV Bewerker",
	"uv_editor.all_faces": "Alle",
	"uv_editor.no_faces": "Geen",
	"face.north": "Noord",
	"face.south": "Zuid",
	"face.west": "West",
	"face.east": "Oost",
	"face.up": "Boven",
	"face.down": "Onder",
	"direction.north": "Noord",
	"direction.south": "Zuid",
	"direction.west": "West",
	"direction.east": "Oost",
	"direction.top": "Bovenkant",
	"direction.bottom": "Onderkant",
	"display.slot.third_right": "Derde Persoon Rechts",
	"display.slot.third_left": "Derde Persoon Links",
	"display.slot.first_right": "Eerste Persoon Rechts",
	"display.slot.first_left": "Eerste Persoon Links",
	"display.slot.head": "Hoofd",
	"display.slot.ground": "Grond",
	"display.slot.frame": "Voorwerplijst",
	"display.slot.gui": "GUI",
	"display.rotation": "Rotatie",
	"display.translation": "Translatie",
	"display.scale": "Schaal",
	"display.slot": "Slot",
	"display.reference": "Verwijs Naar Model",
	"display.reference.player": "Speler",
	"display.reference.zombie": "Zombie",
	"display.reference.armor_stand": "Armor Stand",
	"display.reference.baby_zombie": "Baby Zombie",
	"display.reference.armor_stand_small": "Small Armor Stand",
	"display.reference.monitor": "Normaal",
	"display.reference.bow": "Boog",
	"display.reference.block": "Blok",
	"display.reference.frame": "Item Frame",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "Inventaris",
	"display.reference.hud": "HUD",
	"display.preset.blank_name": "Vul een naam in a.u.b.",
	"display.preset.item": "Standaard Item",
	"display.preset.block": "Standaard Blok",
	"display.preset.handheld": "Standaard Wapen",
	"display.preset.rod": "Standaard Rod",
	"dialog.continue": "Doorgaan",
	"message.square_textures": "Texturen moeten vierkant zijn",
	"message.unsaved_texture.title": "Niet Opgeslagen Textuur",
	"message.unsaved_texture.message": "Alle niet opgeslagen veranderingen van deze textuur zullen verloren gaan. Wil je doorgaan?",
	"action.vertex_snap_mode.move": "Beweeg",
	"action.vertex_snap_mode.scale": "Schaal",
	"action.open_model_folder": "Open Model Map",
	"action.open_model_folder.desc": "Opend de map waar het model in zit",
	"action.change_textures_folder": "Verander Textuur Locatie",
	"action.change_textures_folder.desc": "Verander de map waar alle texturen zijn opgeslagen",
	"menu.texture.particle": "Gebruik voor Deeltjes",
	"message.update_notification.title": "Er is een update van Blockbench beschikbaar.",
	"message.update_notification.message": "Blockbench versie %0 is uit. Wil je deze nu installeren?",
	"message.untextured": "Dit vlak heeft geen textuur",
	"dialog.toolbar_edit.title": "Aangepast Gereedschap",
	"keybindings.reset": "Reset",
	"keybindings.clear": "Leeg",
	"action.cube_counter": "Blok teller",
	"action.uv_rotation": "UV Rotatie",
	"action.uv_rotation.desc": "Rotatie van het UV vlak",
	"action.uv_grid": "UV Rooster",
	"action.uv_grid.desc": "De resolutie van het rooster waarnaar de UV selector snapt",
	"action.uv_grid.auto": "Automatisch",
	"action.uv_maximize": "Maximaliseer UV",
	"action.uv_maximize.desc": "Stelt de UV voor dit vlak in op de hele textuur",
	"action.uv_auto": "Auto UV",
	"action.uv_auto.desc": "Stelt de UV grootte voor dit vlak in op de werkelijke grootte van het vlak",
	"action.uv_rel_auto": "Rel. Auto UV",
	"action.uv_rel_auto.desc": "Verandert de positie van de UV van dit vlak naar de positie en grootte van het werkelijke vlak",
	"action.uv_mirror_x": "UV Spiegelen X",
	"action.uv_mirror_x.desc": "Spiegelt de UV van dit vlak op de X as",
	"action.uv_mirror_y": "UV spiegel Y",
	"action.uv_mirror_y.desc": "Spiegelt de UV van dit vlak op de Y as",
	"action.uv_transparent": "Verwijder Vlak",
	"action.uv_transparent.desc": "Verwijdert het huidige vlak",
	"action.uv_reset": "Reset Vlak",
	"action.uv_reset.desc": "Reset het huidige vlak",
	"action.cullface": "Cullface",
	"action.cullface.desc": "Verbergt dit vlK wanneer de geselecteerde zijkant van dit model is bedekt",
	"action.auto_cullface": "Auto Cullface",
	"action.auto_cullface.desc": "Verandert de cullface voor dit vlak naar zichzelf",
	"action.face_tint": "Tint",
	"action.face_tint.desc": "Zet de tint optie voor het huidige vlak aan",
	"menu.toolbar.edit": "Aanpassen",
	"menu.toolbar.reset": "Resetten",
	"uv_editor.rotated": "Geroteerd",
	"uv_editor.auto_cull": "Cullface Naar Zichzelf",
	"uv_editor.copied": "Vlak Gekopieerd",
	"uv_editor.pasted": "Vlak Geplakt",
	"uv_editor.copied_x": "%0 Vlakken Gekopieerd",
	"uv_editor.reset": "Herstel Vlak",
	"uv_editor.maximized": "Gemaximaliseerd",
	"uv_editor.autouv": "Auto Grootte",
	"uv_editor.mirrored": "Gespiegeld",
	"uv_editor.to_all": "Toegepast Op Alle Vlakken",
	"uv_editor.transparent": "Doorzichtig Gemaakt",
	"uv_editor.cullface_on": "Cullface Aan",
	"uv_editor.cullface_off": "Cullface Uit",
	"uv_editor.tint_on": "Tint Aan",
	"uv_editor.tint_off": "Tint Uit",
	"action.uv_apply_all": "Pas Toe Op Alle Vlakken",
	"action.uv_apply_all.desc": "Past de huidige instelling toe op alle vlakken",
	"message.image_editor_missing.title": "Standaard Afbeelding Editor",
	"message.image_editor_missing.message": "Selecteer het executeerbare bestand van je afbeeldingsbewerker.",
	"message.image_editor_missing.detail": "Blockbench kon geen afbeelding editor vinden op jouw computer. Selecteer het executeerbare bestand van jouw gewenste afbeeldingsbewerker.",
	"action.update_autouv": "Update Auto UV",
	"action.update_autouv.desc": "Update de auto UV van de geselecteerde",
	"category.uv": "UV",
	"status_bar.saved": "Model is opgeslagen",
	"status_bar.unsaved": "Er zijn onopgeslagen veranderingen",
	"action.move_up": "Beweeg omhoog",
	"action.move_up.desc": "Beweeg de geselecteerde kubussen omhoog in opzicht van de huidige camerahoek",
	"action.move_down": "Beweeg naar beneden",
	"action.move_down.desc": "Beweeg de geselecteerde kubussen naar beneden ten opzichte van de huidige camerahoek",
	"action.move_left": "Beweeg Naar Links",
	"action.move_left.desc": "Beweeg de geselecteerde kubussen naar links ten opzichte van de huidige camera hoek",
	"action.move_right": "Beweeg Naar Rechts",
	"action.move_right.desc": "Beweeg de geselecteerde kubussen naar rechts ten opzichte van de huidige camera hoek",
	"action.move_forth": "Beweeg naar voren",
	"action.move_forth.desc": "Beweeg de geselecteerde kubussen naar voren ten opzichte van de huidige camera hoek",
	"action.move_back": "Beweeg naar achteren",
	"action.move_back.desc": "Beweeg de geselecteerde kubussen naar achteren ten opzichte van de huidige camera hoek",
	"layout.color.wireframe": "Wireframe",
	"layout.color.wireframe.desc": "Wireframe bekijk lijnen",
	"layout.color.wireframe_selectable": "Selecteerbare wireframe",
	"layout.color.wireframe_selectable.desc": "Niet-geselecteerde randen en hoekpunten van de actieve mesh in bewerkingsmodus",
	"action.add_animation": "Voeg Animatie Toe",
	"action.add_animation.desc": "Maak een blanco animatie",
	"action.load_animation_file": "Import Animatie",
	"action.load_animation_file.desc": "Import een animatie bestand",
	"action.play_animation": "Speel Animaties",
	"action.play_animation.desc": "Voorvertoning de geselecteerde animatie",
	"action.slider_keyframe_time": "Tijdcode",
	"action.slider_keyframe_time.desc": "Verander de tijdcode van de geselecteerde keyframes",
	"timeline.rotation": "Rotatie",
	"timeline.position": "Positie",
	"timeline.scale": "Schaal",
	"menu.keyframe.quaternion": "Quaternion",
	"panel.animations": "Animaties",
	"panel.keyframe": "Keyframe",
	"panel.keyframe.type": "Keyframe (%0)",
	"generic.delete": "Verwijder",
	"generic.rename": "Hernoem",
	"message.no_animation_selected": "Je moet een animatie selecteren om dit te doen",
	"message.no_bone_selected": "Je moet een bot selecteren om dit te doen",
	"message.duplicate_groups.title": "Bot Naam Dupliceren",
	"message.duplicate_groups.message": "De naam van dit bot bestaat op meerdere botten. Dit kan voor problemen zorgen.",
	"action.delete_keyframes": "Verwijder Keyframes",
	"action.delete_keyframes.desc": "Verwijder alle geselecteerde keyframes",
	"menu.animation": "Animatie",
	"menu.animation.loop": "Herhaal",
	"menu.animation.override": "Overschrijf",
	"menu.animation.anim_time_update": "Update Nummer",
	"message.display_skin_model.title": "Skin Model",
	"message.display_skin_model.message": "Kies je type skin",
	"message.display_skin_model.classic": "Klassiek (steve)",
	"message.display_skin_model.slim": "Slim (alex)",
	"message.bone_material": "Verander materiaal",
	"action.slider_animation_length": "Animatie Lengte",
	"action.slider_animation_length.desc": "Verander de lengte van de geselecteerde animatie",
	"panel.variable_placeholders": "Variabele Plaatshouder",
	"panel.variable_placeholders.info": "Maak een lijst van de variabele s die je vooraf wil zien via naam=waarde",
	"status_bar.vertex_distance": "Afstand: %0",
	"dialog.create_gif.title": "Neem GIF Op",
	"dialog.create_gif.length": "Tijdsduur",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.play": "Start Animatie",
	"category.animation": "Animatie",
	"action.record_model_gif": "Neem GIF Op",
	"action.record_model_gif.desc": "Neem een geanimeerde GIF op van het model van de huidige hoek",
	"display.mirror": "Spiegel",
	"data.separator": "Scheidingsteken",
	"menu.preview.background.set_position": "Stel Positie In",
	"dialog.toolbar_edit.hidden": "Verborgen",
	"action.export_class_entity": "Exporteer Java Editie Entiteit",
	"action.export_class_entity.desc": "Exporteer het entity model als een Java klasse",
	"settings.seethrough_outline": "X-Ray Buitenlijnen",
	"settings.seethrough_outline.desc": "Laat buitenlijnen door voorwerpen heen zien",
	"mode.edit": "Bewerk",
	"mode.paint": "Verf",
	"mode.display": "Positie",
	"mode.animate": "Animeer",
	"status_bar.recording_gif": "Opnemen GIF",
	"status_bar.processing_gif": "Verwerken GIF",
	"settings.backup_retain": "Backup Ophalen Duratie",
	"settings.backup_retain.desc": "Stel in hoe lang Blockbench oude updates ophaalt in dagen",
	"action.rotate_tool": "Roteer",
	"action.rotate_tool.desc": "Gereedschap om elementen te selecteren en te draaien",
	"action.fill_tool": "Verf Emmer",
	"action.fill_tool.desc": "Verf emmer om hele vlakken met een kleur te bedekken",
	"action.eraser": "Gum",
	"action.eraser.desc": "Gum gereedschap om kleuren op texturen met transparantie te vervangen",
	"action.color_picker": "Kleur Pipet",
	"action.color_picker.desc": "Gereedschap om de kleur van de pixels op je textuur te selecteren",
	"switches.mirror": "Spiegel UV",
	"language_name": "Nederlands",
	"message.plugin_reload": "%0 lokale plugins herlaadden",
	"settings.brightness": "Helderheid",
	"settings.brightness.desc": "Helderheid van de voorvertoning. Standaard is 50",
	"menu.preview.perspective.reset": "Herstel Camera",
	"action.fill_mode": "Vul Modus",
	"action.fill_mode.face": "Vlak",
	"action.fill_mode.color": "Kleur",
	"action.toggle_mirror_uv": "Spiegel UV",
	"action.toggle_mirror_uv.desc": "Zet de UV spiegeling op de X as van de geselecteerde kubus aan/uit",
	"menu.texture.blank": "Breng aan op Ongetextuurde Vlakken",
	"dialog.scale.select_overflow": "Selecteer Overflow",
	"action.action_control": "Actie Controle",
	"action.action_control.desc": "Zoek en voer elke beschikbare actie uit",
	"keybindings.recording": "Neem Toetsbinding Op",
	"keybindings.press": "Druk op een knop of een combinatie van knoppen of klik ergens op het scherm om toetsbinding op te nemen",
	"action.pivot_tool": "Draai Gereedschap",
	"action.pivot_tool.desc": "Gereedschap om het Draaipunt van de kubussen en botten te veranderen",
	"action.slider_animation_speed": "Terugspeelsnelheid",
	"action.slider_animation_speed.desc": "Terugspeelsnelheid van de tijdlijn in percent",
	"action.previous_keyframe": "Vorige Keyframe",
	"action.previous_keyframe.desc": "Spring naar de vorige keyframe",
	"action.next_keyframe": "Volgende Keyframe",
	"action.next_keyframe.desc": "Spring naar de volgende Keyframe",
	"message.outdated_client.title": "Verouderde client",
	"message.outdated_client.message": "Alstublieft update naar de laatste versie van Blockbench om dit te doen",
	"action.export_asset_archive": "Download Archief",
	"action.export_asset_archive.desc": "Download een archief met model en alle texturen erin",
	"action.upload_sketchfab": "Sketchfab Upload",
	"message.sketchfab.name_or_token": "Alstublieft vul uw Sketchfab token en een naam in",
	"dialog.sketchfab_uploader.title": "Upload Sketchfab Model",
	"dialog.sketchfab_uploader.token": "API Token",
	"dialog.sketchfab_uploader.about_token": "De token is gebruikt om Blockbench met u Sketchfab account te verbinden. U can het vinden op %0",
	"dialog.sketchfab_uploader.name": "Model Naam",
	"dialog.sketchfab_uploader.description": "Beschrijving",
	"dialog.sketchfab_uploader.tags": "Tags",
	"settings.sketchfab_token": "Sketchfab Token",
	"settings.sketchfab_token.desc": "Token om blockbench te autoriseren om te uploaden naar u Sketchfab account",
	"panel.color": "Kleur",
	"data.origin": "Draaipunt",
	"message.sketchfab.success": "Model succesvol geüpload",
	"message.sketchfab.error": "Gefaald om model up te loaden naar Sketchfab",
	"settings.outliner_colors": "Omlijning Kleuren",
	"settings.outliner_colors.desc": "Laat kubus kleuren in de omlijning zien",
	"action.upload_sketchfab.desc": "Upload je model naar Sketchfab",
	"action.element_colors": "Kubus Kleuren",
	"action.element_colors.desc": "Toon kubus kleuren in de omlijning",
	"texture.error.file": "Bestand niet gevonden",
	"texture.error.parent": "Textuur bestand geleverd door ouder model",
	"message.recover_backup.title": "Haal Model Terug",
	"message.recover_backup.message": "Blockbench was gesloten zonder opslaan. Wil je het model terughalen?",
	"message.invalid_session.title": "Ongeldige Sessie Token",
	"message.invalid_session.message": "De sessie waar je aan probeert toe te treden is verlopen of de token gegeven is ongeldig.",
	"dialog.create_texture.power": "Macht-van-2 Grootte",
	"dialog.create_gif.turn": "Draaitafel Snelheid",
	"action.edit_session": "Bewerk Sessie...",
	"action.edit_session.desc": "Verbind met een bewerk sessie om samen te werken met andere gebruikers",
	"action.reset_keyframe": "Herstel Keyframe",
	"action.reset_keyframe.desc": "Herstel alle waarden van de geselecteerde keyframes",
	"dialog.edit_session.title": "Bewerk Sessie",
	"edit_session.username": "Gebruikersnaam",
	"edit_session.token": "Token",
	"edit_session.about": "Bewerk Sessies kan gebruikt worden om samen te weken met modellen over het internet. Maak een sessie en copiëer de token en verstuur het naar vrienden, die het dan kan gebruiken om toe te treden.",
	"edit_session.join": "Treed Toe Tot Sessie",
	"edit_session.create": "Maak Sessie",
	"edit_session.quit": "Ga Uit Sessie",
	"edit_session.joined": "%0 is toegetreden tot de sessie",
	"edit_session.left": "%0 is uit de sessie gegaan",
	"edit_session.quit_session": "Uit de huidige sessie gegaan",
	"edit_session.status": "Status",
	"edit_session.hosting": "Hosten",
	"edit_session.connected": "Verbonden met een sessie",
	"dialog.sketchfab_uploader.private": "Privé (Pro)",
	"dialog.sketchfab_uploader.password": "Password (Pro)",
	"action.uv_select_all": "Selecteer Alles",
	"action.uv_select_all.desc": "Selecteer alle vlakken in het UV dialoog",
	"panel.chat": "Chat",
	"edit_session.welcome": "Welkom bij deze sessie door %0",
	"dialog.yes": "Ja",
	"dialog.no": "Nee",
	"generic.remove": "Verwijder",
	"generic.download": "Download",
	"generic.search": "Zoek",
	"dates.today": "Vandaag",
	"dates.yesterday": "Gisteren",
	"dates.this_week": "Deze week",
	"dates.weeks_ago": "%0 weken geleden",
	"mode.start.new": "Nieuw",
	"mode.start.recent": "Recent",
	"format.free": "Vrij Model",
	"format.free.desc": "Model zonder beperkingen. Voor game engines, rendering etc.",
	"format.java_block": "Java Blok/Item",
	"format.java_block.desc": "Blok model voor Java Editie. Grootte en rotatie zijn gelimiteerd",
	"format.bedrock": "Bedrock Model",
	"format.bedrock.desc": "Model voor Bedrock Editie",
	"format.bedrock_old": "Bedrock Legacy Model",
	"format.bedrock_old.desc": "Voor-1.12 Bedrock Editie entity model",
	"format.modded_entity": "Modded Entity",
	"format.modded_entity.desc": "Entity model voor mods. Kan geëxporteerd worden als .java class bestanden",
	"format.optifine_entity": "OptiFine Entity",
	"format.optifine_entity.desc": "Custom entity model voor OptiFine",
	"keys.mouse": "Muis Knop %0",
	"message.cleared_blank_faces.title": "Blanke Vlakken",
	"message.cleared_blank_faces.message": "Blockbench heeft %0 kubussen zonder textuur gevonden. Wil je deze elementen verwijderen",
	"message.wireframe.enabled": "Wireframe beeld ingeschakeld",
	"message.wireframe.disabled": "Wireframe beeld uitgeschakeld",
	"dialog.convert_project.title": "Coverteer Project",
	"dialog.create_texture.double_use": "Houd Meer Textuur Gebruik",
	"dialog.model_stats.title": "Model Stats",
	"dialog.model_stats.cubes": "Kubussen",
	"dialog.model_stats.locators": "Locators",
	"dialog.model_stats.groups": "Groepen",
	"dialog.model_stats.vertices": "Vertices",
	"dialog.model_stats.faces": "Vlakken",
	"settings.username": "Gebruikersnaam",
	"settings.username.desc": "Gebruikersnaam voor bewerk sessie",
	"settings.painting_grid": "Verf Grid",
	"settings.painting_grid.desc": "Toon grid op getextuurde kubussen in verf modus",
	"action.convert_project": "Converteer Project",
	"action.convert_project.desc": "Converteerd het huidige project in een project van een ander format",
	"action.close_project": "Sluit Project",
	"action.close_project.desc": "Sluit het huidige open project",
	"action.export_bedrock": "Exporteer Bedrock Geometrie",
	"action.export_bedrock.desc": "Exporteer het model als een Bedrock editie geometrie bestand.",
	"action.save_project": "Sla Project Op",
	"action.save_project.desc": "Slaat het huidige model op als een project bestand",
	"action.save_project_as": "Sla Project Op Als",
	"action.save_project_as.desc": "Slaat het huidige model op als een project bestand op een nieuwe locatie",
	"action.export_over": "Overschrijf Model",
	"action.export_over.desc": "Slaat het model, texturen en animaties op door de bestanden te overschrijven",
	"action.add_locator": "Voeg Locator toe",
	"action.add_locator.desc": "Voegt een nieuwe locator toe om posities van deeltjes, leashes etc. the controleren",
	"action.uv_turn_mapping": "Draai Mapping",
	"action.uv_turn_mapping.desc": "Draai de UV mapping rond met 90 graden",
	"action.remove_blank_faces": "Verwijder Lege Vlakken",
	"action.remove_blank_faces.desc": "Verwijderd alle ongetextuurde vlakken van de selectie",
	"web.download_app": "Download App",
	"uv_editor.turned": "Gedraaide Mapping",
	"display.reference.crossbow": "Kruisboog",
	"dialog.settings.search_results": "Zoek Resultaten",
	"settings.animation_snap": "Animatie Snap",
	"settings.animation_snap.desc": "Snap interval voor keyframes in de animatie tijdlijn in stappen per seconde",
	"action.import_optifine_part": "Importeer OptiFine Onderdeel",
	"action.import_optifine_part.desc": "Importeer een entity deel model voor OptiFine",
	"data.locator": "Locator",
	"mode.start.no_recents": "Geen recent geopende modellen",
	"panel.element": "Element",
	"panel.element.position": "Positie",
	"panel.element.size": "Grootte",
	"panel.element.origin": "Draaipunt",
	"panel.element.rotation": "Rotatie",
	"message.canvas_limit_error.title": "Canvas limiet Error",
	"message.canvas_limit_error.message": "De actie kon niet correct worden uitgevoerd omdat het format het canvas limiteert tot 48 eenheden. Verschuif het draaipunt om dit te voorkomen.",
	"data.effect": "Effect",
	"generic.name": "Naam",
	"settings.recent_projects": "Recent Model Limiet",
	"settings.recent_projects.desc": "Maximale aantal recente modellen om te onthouden",
	"settings.volume": "Volume",
	"settings.volume.desc": "Volume controle voor geluidseffecten in animaties",
	"action.clear_timeline": "Verwijder alles op tijdlijn",
	"action.clear_timeline.desc": "Verwijder alle ongeselecteerde botten van de tijdlijn.",
	"action.select_effect_animator": "Animeer Effecten",
	"action.select_effect_animator.desc": "Opent de tijdlijn om geluid en deeltjes effecten toe te voegen",
	"action.timeline_focus": "Kanaal",
	"action.timeline_focus.desc": "Selecteer de animatie kanalen om op de tijdlijn te laten zien",
	"timeline.particle": "Deeltje",
	"timeline.sound": "Geluid",
	"timeline.effects": "Effecten",
	"data.format": "Formaat",
	"format.optifine_part": "OptiFine Deel",
	"format.optifine_part.desc": "JPM deel voor OptiFine entity modellen",
	"action.reverse_keyframes": "Draai Keyframes Om",
	"action.reverse_keyframes.desc": "Draai de volgorde van de geselecteerde keyframes om",
	"generic.help": "Help",
	"message.removed_faces": "%0 vlakken verwijderd",
	"dialog.sketchfab_uploader.draft": "Draft",
	"action.slider_pos": "Beweeg %0",
	"action.slider_pos.desc": "Beweeg kubussen op de %0 as",
	"action.slider_size": "Grootte %0",
	"action.slider_size.desc": "Herschaal kubussen op de %0 as",
	"action.slider_rotation": "Roteer %0",
	"action.slider_rotation.desc": "Roteer kubussen op de %0 as",
	"action.slider_origin": "Draaipunt %0",
	"action.slider_origin.desc": "Verplaats draaipunt op de %0 as",
	"action.rotate_cw": "Roteer %0 +90",
	"action.rotate_cw.desc": "Roteer de geselecteerde kubussen 90° om de %0 as",
	"action.rotate_ccw": "Roteer %0 -90",
	"action.rotate_ccw.desc": "Roteer de geselecteerde kubussen -90° op de %0 as",
	"action.flip": "Draai %0 om",
	"action.flip.desc": "Draai de geselecteerde kubussen om rond de %0 as",
	"action.center": "Centreer %0",
	"action.center.desc": "Centreer de geselecteerde kubussen om de %0 as",
	"action.bring_up_all_animations": "Toon Alle Animaties",
	"panel.bone": "Bot",
	"data.color": "Kleur",
	"generic.export": "Exporteren",
	"generic.none": "Geen",
	"status_bar.recording": "Timelapse Aan Het Opnemen",
	"message.add_to_palette": "Toegevoegd aan palet",
	"message.size_modifiers": "Houd Ctrl of Shift vast om met ",
	"message.timelapse_start": "Timelapse gestart ",
	"message.timelapse_stop": "Timelapse gestopt",
	"message.import_palette.replace_palette": "Vervang oud palet",
	"message.import_palette.threshold": "Voeg Drempel Samen",
	"dialog.timelapse.interval": "Interval (Seconden)",
	"dialog.timelapse.source": "Bron",
	"dialog.timelapse.source.interface": "Deactiveer het grootte limiet voor specifieke model formaten. WARNING: Dit kan ongeldige modellen veroorzaken.",
	"dialog.timelapse.source.locked": "Vastgezette Hoek",
	"dialog.timelapse.destination": "Bestemmingsmap",
	"layout.color.checkerboard": "Dambord",
	"layout.color.checkerboard.desc": "Achtergrond van canvas en UV editor",
	"layout.font.code": "Code Font",
	"layout.css": "Custom CSS",
	"settings.category.paint": "Verf",
	"settings.deactivate_size_limit": "De",
	"settings.deactivate_size_limit.desc": "Deactiveer het grootte limiet voor specifieke model formaten. WAARSCHUWING:Dit kan zorgen voor ongeldige modellen.",
	"settings.brush_opacity_modifier": "Kwast Ondoorzichtigheid Bewerker",
	"settings.brush_opacity_modifier.desc": "Bewerk de kwast ondoorzichtigheid waneer een stylus wordt gebruikt",
	"settings.brush_size_modifier": "Kwast Grootte Bewerker",
	"settings.brush_size_modifier.desc": "Bewerk de kwast grootte wanneer een pen wordt gebruikt",
	"settings.brush_modifier.pressure": "Druk",
	"settings.brush_modifier.tilt": "Tilt",
	"category.color": "Kleur",
	"action.import_theme": "Importeer Thema",
	"action.export_theme": "Exporteer Thema",
	"action.export_theme.desc": "Maak een thema bestand gebaseerd op huidige instellingen",
	"action.slider_color_h": "Tint",
	"action.slider_color_s": "Verzadiging",
	"action.slider_color_v": "Waarde",
	"action.add_to_palette": "Voeg toe aan palet",
	"action.add_to_palette.desc": "Voeg de geselecteerde kleur toe aan het kleurenpalet",
	"action.import_palette": "Importeer palet",
	"action.import_palette.desc": "Een paletbestand importeren",
	"action.export_palette": "Exporteer Palet",
	"action.export_palette.desc": "Exporteer palet als een .GPL bestand",
	"action.generate_palette": "Genereer Palet",
	"action.generate_palette.desc": "Genereer palette van een textuur",
	"action.sort_palette": "Sorteer Palet",
	"action.sort_palette.desc": "Sorteer alle kleuren op het palet op basis van kleur en helderheid",
	"action.timelapse": "Timelapse...",
	"action.timelapse.desc": "Neem een timelapse van u modeleer proces op",
	"action.add_keyframe": "Voeg Keyframe toe",
	"action.add_keyframe.desc": "Voeg Automatisch een keyframe toe. Druk op shift om standaard waarden te forceren",
	"action.bring_up_all_animations.desc": "Brengt alle gemodificeerde animatoren in de tijdlijn",
	"timeline.timeline": "Instructies",
	"menu.palette.load.default": "Standaard",
	"generic.import": "Importeer",
	"settings.brush_modifier.none": "Geen",
	"action.export_entity": "Exporteer Bedrock Entity",
	"action.export_entity.desc": "Voeg het huidige model als een enitity toe aan een mobs.json bestand",
	"settings.highlight_cubes": "Markeer Kubussen",
	"settings.highlight_cubes.desc": "Markeer kubussen waneer je over ze heen beweegt of ze selecteert",
	"action.add_marker": "Stel Markeerder In",
	"action.add_marker.desc": "Stel een tijdlijn markeerder in",
	"timeline.pre_effect_script": "Script",
	"format.skin": "Skin",
	"format.skin.desc": "Wijzig speler en entiteit skins",
	"message.sketchfab.setup_guide": "Wil je leren hoe je modellen moet instellen op Sketchfab? Lees %0",
	"dialog.skin.title": "Maak Skin",
	"dialog.skin.model": "Skin",
	"action.toggle_skin_layer": "Zet Skin Laag Aan/Uit",
	"action.toggle_skin_layer.desc": "Zet de hoed- en klerenlaag van het skin model aan/uit",
	"action.gui_light": "GUI Licht",
	"action.gui_light.desc": "Selecteer de manier waarop het item is belicht in de inventaris",
	"action.gui_light.side": "Zijkant Licht",
	"action.gui_light.front": "Voorkant Licht",
	"action.move_keyframe_back": "Beweeg Keyframes Naar Achteren",
	"action.move_keyframe_forth": "Beweeg Keyframes Naar Voren",
	"menu.help": "Help",
	"menu.help.discord": "Discord Server",
	"menu.help.report_issue": "Rapporteer een probleem",
	"menu.help.plugin_documentation": "Plugin API Documentatie",
	"menu.help.search_action": "Zoek en Voer Actie uit",
	"menu.help.donate": "Doneer",
	"menu.help.about": "Over...",
	"menu.preview.background.clipboard": "Laad van Klembord",
	"dialog.ignore": "Negeer",
	"generic.unset": "Ongezet",
	"message.invalid_builtin_parent.title": "Ongeldige Ingebouwde Ouder",
	"message.invalid_builtin_parent.message": "De link naar het ongeldige ouder model '%0' was verwijderd om een geldig model te exporteren",
	"dialog.resize_texture.fill": "Vul met",
	"dialog.resize_texture.fill.transparent": "Transparant",
	"dialog.resize_texture.fill.color": "Kleur",
	"dialog.resize_texture.fill.repeat": "Herhaal",
	"dialog.scale.element_pivot": "Element Draaipunt",
	"dialog.scale.selection_center": "Selectie Midden",
	"dialog.create_gif.length_mode": "Lengte Modus",
	"dialog.create_gif.length_mode.seconds": "Seconden",
	"dialog.create_gif.length_mode.frames": "Frames",
	"dialog.create_gif.length_mode.animation": "Animatie Lengte",
	"dialog.create_gif.length_mode.turntable": "Draaitafel Rotatie",
	"dialog.save_angle.projection": "Projectie",
	"dialog.save_angle.projection.perspective": "Perspectief",
	"dialog.save_angle.projection.orthographic": "Orthografisch",
	"dialog.sketchfab_uploader.animations": "Animaties",
	"dialog.settings.theme": "Thema",
	"settings.category.interface": "Interface",
	"settings.preview_checkerboard": "Preview Dambord",
	"settings.preview_checkerboard.desc": "Zet de dambord achtergrond achter de voorvertoning aan/uit",
	"settings.uv_checkerboard": "UV Bewerker Dambord",
	"settings.uv_checkerboard.desc": "Zet de dambord achtergrond achter de UV bewerker aan/uit",
	"category.paint": "Verf",
	"action.fill_mode.color_connected": "Verbonden Kleuren",
	"action.draw_shape_type": "Vorm Type",
	"action.draw_shape_type.rectangle": "Rechthoek",
	"action.draw_shape_type.rectangle_h": "Rechthoek (Hol)",
	"action.draw_shape_type.ellipse": "Elipse",
	"action.draw_shape_type.ellipse_h": "Elipse (Hol)",
	"action.draw_shape_type.line": "Lijn",
	"action.mirror_painting": "Spiegel Schilderij",
	"action.mirror_painting.description": "Spiegel je verfstreken naar de andere kant van het model",
	"action.lock_alpha": "Zet Alpha Kanaal Vast",
	"action.lock_alpha.description": "Zet de doorzichtigheid van alle pixels vast",
	"action.draw_shape_tool": "Teken Vorm",
	"action.draw_shape_tool.desc": "Gereedschap om simpele vormen op texturen tekenen",
	"action.export_gltf": "Exporteer Als glTF",
	"action.export_gltf.desc": "Exporteer model en animaties als glTF bestand voor delen en rendering",
	"action.transform_space": "Transformeer Ruimte",
	"action.transform_space.desc": "Standaard transformeer ruimte voor elementen en botten",
	"action.transform_space.global": "Globaal",
	"action.transform_space.local": "Lokaal",
	"action.toggle_camera_projection": "Schakel Camera Projectie",
	"action.toggle_camera_projection.desc": "Schakel de cameraprojectie tussen perspectief en orthografisch",
	"action.load_camera_angle": "Camerahoek: %0",
	"action.load_camera_angle.desc": "Laad de camerahoek '%0'.",
	"action.slider_face_tint": "Tint Index",
	"action.slider_face_tint.desc": "Set de tint index van ",
	"menu.help.quickstart": "Snelstart Assistent",
	"menu.help.developer": "Ontwikkelaar",
	"menu.help.developer.dev_tools": "Open Dev Gereedschap",
	"menu.help.developer.reset_storage": "Fabrieksherstel",
	"menu.help.developer.reset_storage.confirm": "Weet je zeker dat je Blockbench wilt resetten naar de fabrieksinstellingen? Dan worden alle aangepaste instellingen, toetsbindingen en geïnstalleerde plugins verwijderd.",
	"menu.help.developer.cache_reload": "Cache Herladen",
	"menu.preview.orthographic": "Orthografisch",
	"menu.preview.save_angle": "Bewaar hoek",
	"menu.preview.angle": "Hoeken",
	"menu.preview.angle.initial": "Oorsprongkelijke hoek",
	"menu.preview.maximize": "Maximaliseer",
	"uv_editor.copy_selection": "Kopieer Selectie",
	"uv_editor.paste_selection": "Plak selectie",
	"uv_editor.copy_paste_tool.place": "Plaats",
	"uv_editor.copy_paste_tool.mirror_x": "Spiegel X",
	"uv_editor.copy_paste_tool.mirror_y": "Spiegel Y",
	"uv_editor.copy_paste_tool.rotate": "Draai 90 graden",
	"dialog.project.modded_entity_version": "Exporteer versie",
	"dialog.save_angle.position": "Camera positie",
	"dialog.save_angle.target": "Brandpunt",
	"dialog.skin.pose": "Poseren",
	"layout.color.frame": "Venster Kader",
	"layout.color.frame.desc": "Borduur en titel van het venster",
	"settings.large_grid_size": "Blokrooster grootte",
	"settings.large_grid_size.desc": "Grootte van het blokrooster",
	"action.load_plugin_from_url": "Laad een plugin via een URL",
	"action.load_plugin_from_url.desc": "Laad een plugin van een server door de URL op te geven",
	"action.cube_counter.desc": "Toont het huidig aantal elementen en andere statistieken",
	"action.unlock_everything": "Ontgrendel alles",
	"action.unlock_everything.desc": "Ontgrendel alle groepen en elementen in de omlijning.",
	"action.load_palette": "Palet laden",
	"action.load_palette.desc": "Laad een van de ingebouwde paletvoorinstellingen",
	"action.toggle_locked": "Schakel Vergrendeling",
	"action.toggle_locked.desc": "Schakel of de huidig geselecteerde elementen vergrendeld moeten worden",
	"action.apply_display_preset": "Pas Preset Toe",
	"action.apply_display_preset.desc": "Pas een standaard of aangepaste weergave-instelling toe",
	"action.apply_display_preset.here": "Pas Toe Naar Dit Slot",
	"action.apply_display_preset.everywhere": "Pas Toe Naar Alle Slots",
	"action.resolve_keyframe_expressions": "Keyframe Oplossen",
	"action.resolve_keyframe_expressions.desc": "Lost de wiskundige uitdrukkingen op van de huidig geselecteerde keyframes",
	"action.fold_all_animations": "Vouw Alle Animators In",
	"menu.palette.load.empty": "Leeg",
	"switches.lock": "Sluit",
	"settings.render_sides": "Render Zijkanten",
	"settings.render_sides.desc": "Selecteer welke kant van het object wordt weergegeven",
	"settings.render_sides.auto": "Automatisch",
	"settings.render_sides.front": "Buiten",
	"settings.render_sides.double": "Binnen en Buiten",
	"generic.enable": "Schakel in",
	"generic.disable": "Schakel uit",
	"generic.redacted": "Geredigeerd",
	"dialog.select_texture.import_all": "Importeer alles",
	"dialog.skin.layer_template": "Laag Textuur",
	"about.version.up_to_date": "Up-to-date",
	"about.version.update_available": "Versie %0 is beschikbaar",
	"settings.category.application": "Applicatie",
	"settings.streamer_mode": "Streamer Modus",
	"settings.streamer_mode.desc": "Verbergt gevoelige informatie, zoals recente modellen",
	"settings.automatic_updates": "Automatische Updates",
	"settings.automatic_updates.desc": "Download de nieuwste versies van BlockBench automatisch om up-to-date te blijven",
	"action.rotation_space": "Rotatie Ruimte",
	"action.focus_on_selection": "Centreer Zicht op Selectie",
	"action.focus_on_selection.desc": "Lijn de camera uit naar het midden van de huidige selectie",
	"action.jump_to_timeline_start": "Spring naar Start Animatie",
	"action.jump_to_timeline_end": "Spring naar Einde Animatie",
	"menu.help.updating": "Updaten (%0%)",
	"menu.help.update_failed": "Updaten Gefaald",
	"menu.animation.loop.once": "Speel één keer af",
	"menu.animation.loop.hold": "Hou Vast Op Laatste Frame",
	"menu.animation.loop.loop": "Herhalen",
	"interface.streamer_mode_on": "Steamer Modus Ingeschakeld",
	"generic.reset": "Reset",
	"generic.restore": "Herstel",
	"keys.mousewheel": "Muiswiel",
	"message.delete_animation.title": "Verwijder Animatie",
	"message.delete_animation.message": "De animatie is verwijderd uit Blockbench. Wil je de animatie ook verwijderden uit het bestand waarin het is opgeslagen?",
	"message.no_animation_to_import": "Geen animaties om te importeren",
	"dialog.material_instances.title": "Materiaal Instanties",
	"dialog.animation_import.title": "Selecteer animaties om te importeren",
	"dialog.create_texture.padding": "Vulling",
	"settings.fov": "FOV",
	"settings.fov.desc": "Camera gezichtsveld. Standaard is 45",
	"settings.minify_bbmodel": "Geminimaliseerde Projectbestanden",
	"settings.minify_bbmodel.desc": "Schrijf .bbmodel bestanden weg geminimaliseerd tot één lijn",
	"action.edit_material_instances": "Wijzig Materiaal Instanties",
	"action.edit_material_instances.desc": "Wijzig de naam van materiaal instanties voor bedrock blok geometrieën",
	"action.save_all_animations": "Bewaar Alle Animaties",
	"action.save_all_animations.desc": "Bewaar alle momenteel geladen animaties",
	"action.keyframe_interpolation": "Interpolatie",
	"action.keyframe_interpolation.desc": "Selecteer de keyframe interpolatiemodus",
	"action.keyframe_interpolation.linear": "Lineair",
	"action.keyframe_interpolation.catmullrom": "Vloeiend",
	"action.timeline_focus.hide_empty": "Verberg lege kanalen",
	"menu.file.preferences": "Voorkeuren",
	"menu.animation.blend_weight": "Mix Gewicht",
	"menu.animation.save": "Bewaar",
	"menu.animation.properties": "Eigenschappen...",
	"menu.animation.file": "Bestand",
	"menu.animation.snapping": "Snapping",
	"menu.animation.open_location": "Open Bestand Locatie",
	"panel.keyframe.add_data_point": "Voeg Keyframe Datapunt toe",
	"panel.keyframe.remove_data_point": "Verwijder Datapunt",
	"panel.keyframe.pre": "Voor",
	"panel.keyframe.post": "Na",
	"generic.all": "Alle",
	"message.small_face_dimensions.title": "Incompatibele Vlak Dimensies",
	"message.small_face_dimensions.message": "De selectie bevat vlakken die kleiner zijn dan 1 eenheid in één richting. Het Box UV mapping systeem beschouwt alle vlakken onder die drempel als 0 pixels breed. De textuur op die vlakken werkt daarom mogelijk niet correct.",
	"message.small_face_dimensions.face_uv": "Het huidige formaat ondersteunt per-vlak UV-maps die kleine vlakafmetingen aankunnen. Ga naar \"Bestand\" > \"Project...\" en verander \"UV Modus\" in \"Per-vlak UV\".",
	"dialog.plugins.outdated_client": "Vereist een nieuwere versie van Blockbench",
	"dialog.plugins.outdated_plugin": "Plugin is verouderd en werkt niet voor deze versie van Blockbench",
	"settings.motion_trails": "Bewegingspaden",
	"settings.motion_trails.desc": "Toon bewegingspaden in de animatie-editor",
	"settings.antialiasing": "Anti-aliasing",
	"settings.antialiasing.desc": "Schakel anti-aliasing in de voorvertoning aan/uit. Herstart Blockbench om de wijzigingen aan te brengen",
	"action.timeline_frame_back": "Spring 1 Frame Terug",
	"action.timeline_frame_forth": "Spring 1 Frame Vooruit",
	"panel.bone.ik": "Inverse Kinematica (Experimenteel)",
	"settings.particle_tick_rate": "Deeltje Tikfrequentie",
	"settings.particle_tick_rate.desc": "Tikfrequentie voor deeltjeseffecten in tikken per seconde. Standaard is 30",
	"action.lock_motion_trail": "Vergrendel Beweginspad",
	"action.lock_motion_trail.desc": "Vergrendel het bewegingspad voor de huidig geselecteerde groep",
	"menu.animation_file.unload": "Bestand Lossen",
	"data.null_object": "Leeg Object",
	"status_bar.toggle_sidebar": "Schakel Zijbalk",
	"message.load_plugin_failed.title": "Kon plugin niet laden",
	"message.load_plugin_failed.message": "Zorg ervoor dat de basisbestandsnaam van de plugin overeenkomt met de plugin-ID `%0`, zoals opgegeven in Plugin.register().",
	"dialog.project.uv_mode": "UV Modus",
	"dialog.project.uv_mode.box_uv": "Box UV",
	"dialog.project.uv_mode.face_uv": "Per-vlak UV",
	"dialog.project.texture_size": "Textuurgrootte",
	"dialog.animation_export.title": "Selecter Animaties om te Exporteren",
	"dialog.create_texture.rearrange_uv": "Herschik UV",
	"layout.color.subtle_text": "Subtiele Tekst",
	"layout.color.subtle_text.desc": "Secundaire tekstkleur met minder contrast",
	"settings.interface_scale": "Interface Schaal",
	"settings.interface_scale.desc": "Schaal van de volledige Blockbench interface",
	"settings.background_rendering": "Renderen op de Achtergrond",
	"settings.background_rendering.desc": "Update de voorvertoning zelfs wanneer het venster niet in focus is",
	"settings.ctrl_shift_size": "Control + Shift Resolutie",
	"settings.ctrl_shift_size.desc": "Resolutie van het grid bij indrukken van control en shift",
	"settings.hardware_acceleration": "Hardware Versnelling",
	"settings.hardware_acceleration.desc": "Besteed renderingstaken uit aan de grafische kaart. Herstart Blockbench om de wijzigingen toe te passen",
	"action.explode_skin_model": "Explodeer Skin Model",
	"action.explode_skin_model.desc": "Schakelt een explosieweergave in waarmee u bedekte vlakken kunt bewerken",
	"action.export_minecraft_skin": "Exporteer Minecraft Skin",
	"action.export_minecraft_skin.desc": "Exporteer de Minecraft skin als een PNG textuur",
	"action.add_null_object": "Voeg Leeg Object Toe",
	"action.add_null_object.desc": "Voegt een nieuw leeg object toe",
	"action.animated_texture_frame": "Geanimeerde Textuur Frame",
	"action.animated_texture_frame.desc": "Stel het huidige frame van de geanimeerde textuur in",
	"action.export_animation_file": "Exporteer Animaties...",
	"action.export_animation_file.desc": "Exporteer een selectie van animaties naar een nieuw bestand",
	"action.timeline_graph_editor": "Schakel Grafiek Editor",
	"action.timeline_graph_editor.desc": "Schakelt de tijdlijn tussen grafiekeditorweergave en keyframe-weergave",
	"menu.file.recent.clear": "Wis Recente Bestanden",
	"switches.shade": "Schaduw",
	"generic.share": "Deel",
	"dates.minute": "%0 Minuut",
	"dates.minutes": "%0 Minuten",
	"dates.hour": "%0 Uur",
	"dates.hours": "%0 Uren",
	"dates.day": "%0 Dag",
	"dates.days": "%0 Dagen",
	"dates.week": "%0 Week",
	"dates.weeks": "%0 Weken",
	"dates.year": "%0 Jaar",
	"dates.years": "%0 Jaren",
	"message.installed_plugin": "De plugin %0 is succesvol geïnstalleerd",
	"message.installed_plugin_fail": "Kon plugin %0 niet installeren",
	"dialog.share_model.title": "Deel Model",
	"dialog.share_model.expire_time": "Vervaltijd",
	"dialog.share_model.failed": "Kon model niet uploaden",
	"action.import_java_block_model": "Voeg Java Blok/Item Model Toe",
	"action.import_java_block_model.desc": "Voeg een Minecraft Java blok/item model uit een json bestand toe aan het huidige model",
	"action.share_model": "Deel...",
	"action.share_model.desc": "Genereer een korte link om uw model te delen",
	"action.import_project": "Importeer Project",
	"action.import_project.desc": "Importeer een ander project uit een .bbmodel-bestand in het huidige project",
	"dialog.toolbar_edit.hidden_tools": "Sommige gereedschappen kunnen verborgen zijn omdat ze niet beschikbaar zijn in de huidige modus, indeling of situatie.",
	"settings.camera_near_plane": "Camera Near Plane",
	"settings.camera_near_plane.desc": "De minimale afstand tot de camera waar objecten worden weergegeven. Hogere waarden verminderen het vechten voor diepte. De standaardwaarde is 1.",
	"mode.start.keymap_preference.desc": "Als u nieuw bent in Blockbench en uit een ander 3D-programma komt, kunt u een toetsenbordindeling selecteren om de overgang te vergemakkelijken. U kunt de toetsenbordindeling of individuele sneltoetsen later wijzigen in de instellingen.",
	"message.load_keymap": "Weet je zeker dat je deze toetsenbordindeling wilt laden? Dit zal je huidige toetsbindingen overschrijven.",
	"message.keymap_loaded": "Toetsenbordindeling geladen",
	"dialog.convert_project.current_format": "Huidig Formaat",
	"dialog.create_texture.rearrange_uv.desc": "Maak een nieuwe UV-indeling om elk vlak zijn eigen plek op de textuur te geven",
	"dialog.create_texture.power.desc": "Beperk de automatische textuurgrootte tot een macht van 2, bijvoorbeeld 64 of 128. Dit is vereist voor sommige renderers",
	"dialog.create_texture.double_use.desc": "Als aan twee elementen al dezelfde UV-ruimte is toegewezen, moet dat zo blijven in de nieuwe map",
	"dialog.create_texture.padding.desc": "Voeg een kleine vulling toe tussen individuele onderdelen van de sjabloon",
	"dialog.create_texture.resolution.desc": "De hoogte en breedte van de textuur",
	"dialog.create_gif.color": "Achtergrond Kleur",
	"dialog.save_angle.zoom": "Zoom",
	"dialog.skin.variant": "Variant",
	"dialog.flip_animation.info": "Tegengestelde botten worden geïdentificeerd door de sleutelwoorden 'links' en 'rechts' in hun naam.",
	"dialog.export_private_settings.title": "Privé Instellingen",
	"dialog.export_private_settings.message": "Uw bestand bevat de volgende privé informatie: **%0**. Laat deze waarden weg als u van plan bent het bestand met iemand anders te delen.",
	"dialog.export_private_settings.keep": "Behoud",
	"settings.timecode_frame_number": "Toon Tijdcodes als Framenummers",
	"settings.timecode_frame_number.desc": "Toont fractie-tijdcodes in de tijdlijn als een framenummer in plaats van centiseconden",
	"settings.animation_sample_rate": "Animatie Bemonstering Frequentie",
	"settings.animation_sample_rate.desc": "Bemonsteringsfrequentie in stalen per seconde voor curven die het respectieve formaat niet van nature ondersteunt",
	"keybind.preview_zoom": "Zoom Weergave",
	"action.gradient_tool": "Gradiënt Gereedschap",
	"action.gradient_tool.desc": "Maak een kleurengradiënt voor uw textuur",
	"action.import_settings": "Importeer Instellingen",
	"action.import_settings.desc": "Importeer een .bbsettings-bestand",
	"action.export_settings": "Exporteer Instellingen",
	"action.export_settings.desc": "Exporteer Blockbench-voorkeuren naar een .bbsettings-bestand",
	"action.load_keymap": "Laad Toetsenbordindeling",
	"action.load_keymap.default": "Standaard (Trackpad/Muis)",
	"action.load_keymap.mouse": "Standaard (Muis)",
	"action.load_keymap.default.desc": "Standaard Blockbench keybindings, met viewport navigatie controls geoptimaliseerd voor gebruik op laptop trackpads",
	"action.load_keymap.mouse.desc": "Standaard Blockbench toetsbindingen, met viewport navigatie gebonden aan de middelste muisknop",
	"action.load_keymap.blender.desc": "Toetsenbordindeling voor gebruikers die vertrouwd zijn met de bediening van Blender",
	"action.load_keymap.cinema4d.desc": "Toetsenbordindeling voor gebruikers die vertrouwd zijn met de bediening van Cinema 4D",
	"action.load_keymap.maya.desc": "Toetsenbordindeling voor gebruikers die vertrouwd zijn met de bediening van Autodesk Maya",
	"action.import_keymap": "Importeer Toestenbordindeling",
	"action.import_keymap.desc": "Importeer sneltoetsen .bbkeymap-bestand",
	"action.export_keymap": "Exporteer Toetsenbordindeling",
	"action.export_keymap.desc": "Exporteer de huidige sneltoetsen als een .bbkeymap-bestand",
	"action.edit_history": "Bewerking Geschiedenis...",
	"action.edit_history.desc": "Bekijk de bewerkingsgeschiedenis en ongedane/herhaalde stappen",
	"action.group_elements": "Groepeer Elementen",
	"action.group_elements.desc": "Wikkel geselecteerde elementen in een nieuwe groep",
	"action.unfold_groups": "Ontvouw Groepen",
	"action.unfold_groups.desc": "Ontvouw alle groepen in de omlijning",
	"action.edit_bedrock_binding": "Bewerk Binding...",
	"action.edit_bedrock_binding.desc": "Verander aan welk bot de geometrie is gebonden",
	"action.pick_screen_color": "Selecter Kleur op Scherm",
	"action.pick_screen_color.desc": "Kies een kleur van ergens op je scherm",
	"action.view_mode": "Weergave Modus",
	"action.view_mode.desc": "Verander het model naar Weergave Modus",
	"action.view_mode.textured": "Getextureerd",
	"action.view_mode.solid": "Massief",
	"action.view_mode.wireframe": "Wireframe",
	"action.toggle_sidebars": "Schakel Zijbalken",
	"action.toggle_sidebars.desc": "Zijbalken in- of uitschakelen",
	"action.set_animation_end": "Stel Animatie-einde In",
	"action.set_animation_end.desc": "Stel het einde van de geselecteerde animatie in op de huidige tijdlijntijd",
	"action.flip_animation": "Draai Animatie Om",
	"action.flip_animation.desc": "Draait een deel van een animatie om door geselecteerde keyframes te kopiëren naar de andere kant van het model",
	"action.graph_editor_zero_line": "Nullijn Meenemen",
	"action.graph_editor_zero_line.desc": "Of de grafiekeditor altijd de nullijn in de weergave omvat",
	"menu.texture.render_mode": "Rendere Modus",
	"menu.texture.render_mode.emissive": "Emissief",
	"menu.texture.render_mode.layered": "Gelaagd",
	"menu.preview.angle.edit": "Bewerk Hoek",
	"menu.animation.start_delay": "Start Vertraging",
	"menu.animation.loop_delay": "Lus Vertraging",
	"menu.animation.flip_keyframes": "Draai Keyframes Om",
	"menu.mobile_keyboard.disable_all": "Alles Uitschakelen",
	"panel.keyframe.toggle_uniform_scale": "Schakel Uniforme Schaal",
	"camera_angle.common_isometric_right": "Isometrisch Rechts (2:1)",
	"camera_angle.common_isometric_left": "Isometrisch Links (2:1)",
	"camera_angle.true_isometric_right": "Rechts Isometrisch (30°)",
	"camera_angle.true_isometric_left": "Links Isometrisch (30°)",
	"menu.help.wiki": "Blockbench Wiki",
	"settings.update_to_prereleases": "Update naar Pre-releases",
	"settings.update_to_prereleases.desc": "Automatisch updaten naar Blockbench beta versies om nieuwe functies te testen. Pre-release versies kunnen onstabiel zijn, schakel deze optie niet in als u vertrouwt op Blockbench voor werk of andere belangrijke projecten.",
	"data.separator.spacer": "Afstandhouder",
	"data.separator.linebreak": "Regeleinde",
	"data.setting": "Instelling",
	"generic.select_all": "Selecteer Alles",
	"generic.select_none": "Selecteer Niets",
	"projects.new_tab": "Nieuw Tabblad",
	"projects.close_tab": "Sluit Tabblad",
	"message.invalid_format.title": "Ongeldig Formaat",
	"message.invalid_format.message": "Dit model is gemaakt in het formaat '%0', dat niet beschikbaar is in uw Blockbench-installatie. U heeft waarschijnlijk een specifieke plugin nodig om het correct te openen.",
	"message.invalid_link": "Ongeldige of Verlopen Model Link",
	"message.default_textures.current": "Huidig pad",
	"message.update_after_restart": "De update zal geïnstalleerd worden na de volgende herstart",
	"message.copy_paste_tool_viewport": "Dit gereedschap kan enkel gebruikt worden in de 2D-editor",
	"dialog.project.shadow_size": "Schaduw Grootte",
	"dialog.find_replace.target": "Doel",
	"dialog.find_replace.target.element_names": "Element Namen",
	"dialog.find_replace.target.group_names": "Groep Namen",
	"dialog.find_replace.target.animation_names": "Animatie Namen",
	"dialog.find_replace.target.keyframe_values": "Keyframe Waardes",
	"dialog.find_replace.find": "Zoek",
	"dialog.find_replace.replace": "Vervang",
	"dialog.find_replace.regex": "Regular Expression",
	"dialog.add_primitive.shape": "Vorm",
	"dialog.add_primitive.shape.circle": "Cirkel",
	"dialog.add_primitive.shape.tube": "Buis",
	"dialog.add_primitive.shape.cone": "Kegel",
	"dialog.add_primitive.shape.cylinder": "Cilinder",
	"dialog.add_primitive.shape.sphere": "Bol",
	"dialog.add_primitive.shape.torus": "Torus",
	"dialog.add_primitive.shape.cube": "Kubusvormig",
	"dialog.add_primitive.shape.pyramid": "Pyramide",
	"dialog.add_primitive.diameter": "Diameter",
	"dialog.add_primitive.height": "Hoogte",
	"dialog.add_primitive.sides": "Zijkanten",
	"dialog.add_primitive.minor_diameter": "Dikte",
	"dialog.add_primitive.minor_sides": "Kleine Kanten",
	"dialog.create_texture.combine_polys": "Combineer Eilanden",
	"dialog.create_texture.combine_polys.desc": "Vlakken combineren tot verbonden UV-eilanden",
	"dialog.model_stats.meshes": "Meshes",
	"dialog.export_private_settings.omit": "Laat Weg",
	"layout.select": "Selecteer",
	"layout.options": "Opties",
	"layout.color": "Kleur Schema",
	"layout.documentation": "Documentatie",
	"layout.color.bright_ui_text": "Heldere UI Tekst",
	"layout.color.bright_ui_text.desc": "Tekst op heldere achtergronden",
	"layout.name": "Naam",
	"layout.author": "Auteur",
	"settings.dialog.desc": "Toon het \"%0\" dialoog",
	"settings.export_empty_groups": "Exporteer Lege Groepen",
	"settings.export_empty_groups.desc": "Lege groepen in geëxporteerde bestanden opnemen",
	"category.separators": "Scheiders",
	"keybind.preview_area_select": "Selecteer Gebied",
	"action.color_erase_mode": "Wis Modus",
	"action.color_erase_mode.desc": "Als de wismodus is ingeschakeld, trekken gereedschappen als Vullen en Rechthoek kleuren af in plaats van ze toe te voegen",
	"action.open_from_link": "Open Model via Link...",
	"action.open_from_link.desc": "Open een model via een blckbn.ch URL",
	"action.import_obj": "Importeer OBJ Model",
	"action.import_obj.desc": "Importeert objecten uit een OBJ-model als meshes",
	"action.add_plugin": "Installeer Plugin",
	"action.add_plugin.desc": "Installeer een plugin via Action Control",
	"action.remove_plugin": "Verwijder Plugin",
	"action.remove_plugin.desc": "Verwijder een plugin via Action Control",
	"action.add_mesh": "Voeg Mesh Toe",
	"action.add_mesh.desc": "Voegt een nieuwe mesh toe",
	"action.add_texture_mesh": "Voeg Texture Mesh Toe",
	"action.add_texture_mesh.desc": "Voegt een nieuwe texture mesh toe",
	"action.find_replace": "Zoek/Vervang...",
	"action.find_replace.desc": "Zoek en vervang delen van namen",
	"action.hide_everything_except_selection": "Verberg Alles Behalve Selectie",
	"action.hide_everything_except_selection.desc": "Schakel zichtbaarheid van alle elementen, behalve de huidig geselecteerden",
	"action.transform_space.normal": "Normaal",
	"action.selection_mode": "Selectie Modus",
	"action.selection_mode.desc": "Verander hoe elementen geselecteerd kunnen worden in de viewport",
	"action.selection_mode.object": "Object",
	"action.selection_mode.face": "Vlak",
	"action.selection_mode.vertex": "Vertex",
	"action.create_face": "Maak Vlak of Rand",
	"action.create_face.desc": "Maakt een nieuw vlak of rand tussen de geselecteerde vertices",
	"action.convert_to_mesh": "Converteer naar Mesh",
	"action.convert_to_mesh.desc": "Converteer de geselecteerde elementen in meshes",
	"action.invert_face": "Inverteer Vlak",
	"action.invert_face.desc": "Inverteer de geselecteerde vlakken zodat ze in de tegenovergestelde richting wijzen",
	"action.extrude_mesh_selection": "Extrudeer Selectie",
	"action.extrude_mesh_selection.desc": "Extrudeer de geselecteerde onderdelen van de mesh",
	"action.loop_cut": "Lus Snede",
	"action.loop_cut.desc": "Splits de mesh in een lus over de geselecteerde rand",
	"action.merge_meshes": "Meshes Samenvoegen",
	"action.merge_meshes.desc": "Voeg verschillende meshes samen tot één mesh",
	"action.keyframe_uniform": "Uniforme Schaling",
	"action.keyframe_uniform.desc": "Schakel uniforme schaling in op de geselecteerde keyframes",
	"menu.locator.ignore_inherited_scale": "Negeer Overgeërfde Schaal",
	"menu.texture.elements": "Pas Toe op Elementen",
	"uv_editor.transparent_face": "Transparant Vlak",
	"display.pose_angle": "Poseerhoek (Enkel in Voorvertoning)",
	"data.mesh": "Mesh",
	"dialog.create_texture.type": "Type",
	"dialog.create_texture.type.blank": "Leeg",
	"dialog.create_texture.type.template": "Textuur Sjabloon",
	"dialog.create_texture.type.color_map": "Effen Kleur Sjabloon",
	"dialog.sketchfab_uploader.suggested_tags": "Voorgestelde Labels",
	"dialog.sketchfab_uploader.category": "Categorie",
	"dialog.sketchfab_uploader.category2": "Categorie 2",
	"layout.restore_backup": "Uw aangepaste thema \"%0\" is overschreven. Klik hier om het te herstellen.",
	"layout.borders": "Randen",
	"action.fill_mode.element": "Element",
	"action.inset_mesh_selection": "Inzet Selectie",
	"action.inset_mesh_selection.desc": "De geselecteerde delen van de mesh inbedden",
	"action.dissolve_edges": "Los Randen Op",
	"action.dissolve_edges.desc": "Geselecteerde randen in een mesh oplossen en de vlakken die ze verdelen samenvoegen",
	"action.split_mesh": "Splits Mesh",
	"action.split_mesh.desc": "Splits de geselecteerde vlakken van de mesh in een nieuwe mesh",
	"action.merge_vertices": "Vertices Samenvoegen",
	"action.merge_vertices.desc": "De geselecteerde vertices samenvoegen op de positie van de eerste geselecteerde vertex",
	"action.view_mode.normal": "Oriëntatie Vlak",
	"action.snap_uv_to_pixels": "Snap UV naar Pixels",
	"action.snap_uv_to_pixels.desc": "Snapt de geselecteerde UV vertices naar het pixel grid",
	"menu.file.import.import_open_project": "Importeer Open Project",
	"menu.help.unlock_projects": "Ontgrendel Alle Projecten",
	"status_bar.selection.faces": "%0 Vlakken",
	"status_bar.selection.vertices": "%0 Vertices",
	"message.merged_vertices": "%0 vertices in %1 locatie(s) gevonden en samengevoegd",
	"settings.vertex_merge_distance": "Vertex Samenvoeg Afstand",
	"settings.vertex_merge_distance.desc": "Afstand waarbinnen vertices worden samengevoegd met behulp van samenvoegen op afstand",
	"settings.show_only_selected_uv": "Toon Enkel Geselecteerde UVs",
	"settings.show_only_selected_uv.desc": "Toont standaard alleen de geselecteerde UV vlakken in de UV-editor",
	"action.merge_vertices.merge_all": "Voeg Alles Samen",
	"action.merge_vertices.merge_all_in_center": "Voeg Alles Samen in Centrum",
	"action.merge_vertices.merge_by_distance": "Voeg Samen volgens Afstand",
	"action.merge_vertices.merge_by_distance_in_center": "Voeg Samen volgens Afstand in Midden",
	"action.uv_rotate_left": "Draai UV Links",
	"action.uv_rotate_left.desc": "Draai het geselecteerde UV vlak tegen de klok in",
	"action.uv_rotate_right": "Draai UV Rechts",
	"action.uv_rotate_right.desc": "Draai het geselecteerde UV vlak met de klok mee",
	"menu.uv.display_uv": "Toon UV",
	"menu.uv.display_uv.selected_faces": "Geselecteerde Vlakken",
	"menu.uv.display_uv.selected_elements": "Alle Vlakken",
	"menu.uv.display_uv.all_elements": "Alle Vlakken op Alle Elementen",
	"menu.paste.face": "UV Vlak",
	"menu.paste.mesh_selection": "Mesh Selectie",
	"menu.paste.outliner": "Elementen",
	"uv_editor.show_all_faces": "Toon Alle Vlakken",
	"uv_editor.show_selected_faces": "Toon Geselecteerde Vlakken",
	"status_bar.selection.edges": "%0 Randen",
	"action.selection_mode.edge": "Rand",
	"message.cannot_re_import.title": "Model kan niet opnieuw geïmporteerd worden",
	"message.cannot_re_import.message": "Het geëxporteerde modelformaat kan niet opnieuw in Blockbench worden geïmporteerd. Zorg ervoor dat u uw model opslaat als een projectbestand.",
	"generic.default": "Standaard",
	"units.pixels_per_meter": "%0 Pixels per Meter",
	"mode.pose": "Houding",
	"modifier_actions.resize_both_sides": "Herschaal in beide richtingen",
	"modifier_actions.resize_one_side": "Herschaal in één richting",
	"modifier_actions.draw_line": "Teken lijn",
	"modifier_actions.drag_without_snapping": "Sleep zonder snapping",
	"modifier_actions.stretch_keyframes": "Rek keyframes",
	"modifier_actions.resize_background": "Herschaal achtergrond",
	"modifier_actions.select_multiple": "Select meerderen",
	"modifier_actions.select_range": "Select bereik",
	"modifier_actions.drag_to_duplicate": "Sleep om te dupliceren",
	"modifier_actions.uniform_scaling": "Uniforme Schaling",
	"modifier_actions.snap_direction": "Snap Richting",
	"message.no_valid_elements": "Geen geldige elementen geselecteerd...",
	"dialog.add_primitive.shape.plane": "Vlak",
	"dialog.save_angle.rotation_mode": "Rotatie Modus",
	"dialog.save_angle.rotation": "Rotatie",
	"dialog.save_angle.fov": "FOV",
	"settings.hide_tab_bar": "Tabbladbalk Automatisch Verbergen",
	"settings.hide_tab_bar.desc": "Verberg de tabbladbalk wanneer slechts één tabblad geopend is",
	"settings.status_bar_modifier_keys": "Wijzigingstoetsen in de statusbalk voorstellen",
	"settings.status_bar_modifier_keys.desc": "Contextbewuste voorgestelde toetsen in de statusbalk weergeven",
	"settings.ground_plane": "Grondvlak",
	"settings.ground_plane.desc": "Toon een vloervlak onder het model",
	"settings.preview_paste_behavior": "Standaard Voorbeeld Plakgedrag",
	"settings.preview_paste_behavior.desc": "Selecteer het gedrag bij het plakken van iets in het voorbeeld in de bewerkingsmodus en er zijn meerdere opties beschikbaar",
	"settings.preview_paste_behavior.always_ask": "Altijd Vragen",
	"action.new_window": "Nieuw Venster",
	"action.new_window.desc": "Opent een nieuw Blockbench venster",
	"action.export_collada": "Exporteer Collada Model (dae)",
	"action.export_collada.desc": "Exporteer modellen en animaties als .dae-bestand voor gebruik in andere 3D-applicaties",
	"action.paint_mode_uv_overlay": "UV Overlay",
	"action.paint_mode_uv_overlay.desc": "De UV-map weergeven als een overlay in verfmodus",
	"action.bake_animation_into_model": "Bak Animatie in Model",
	"action.bake_animation_into_model.desc": "Bak het huidig weergegeven animatieframe in het model. Past alleen rotatie en positie toe, schaal wordt genegeerd.",
	"action.keyframe_interpolation.step": "Stap",
	"action.set_ik_target": "Stel IK Doel In",
	"action.set_ik_target.desc": "Selecteer het doelbot dat door dit leeg object moet worden verplaatst via Inverse Kinematica",
	"menu.action_control.type.tab": "Tab",
	"menu.action_control.type.angle": "Camera Hoek",
	"menu.action_control.recent_in_streamer_mode": "Zeker weten? Streamer Modus is ingeschakeld",
	"menu.action_control.recent_in_streamer_mode.desc": "Bent u zeker dat u recente modellen wilt weergeven?",
	"menu.tools": "Gereedschappen",
	"menu.file.recent.more": "Meer Bekijken...",
	"menu.null_object.lock_ik_target_rotation": "Vergrendel Rotatie van IK Doel",
	"menu.animation_file.import_remaining": "Importeer Resterend van Bestand",
	"edit.loop_cut.offset": "Offset",
	"edit.extrude_mesh_selection.extend": "Breid Uit",
	"cube.color.pink": "Roze",
	"cube.color.silver": "Zilver",
	"dialog.plugins.offline": "Geen internetverbinding",
	"dialog.create_texture.pixel_density": "Pixel Dichtheid",
	"dialog.create_texture.pixel_density.desc": "De pixeldichtheid van de textuur, in pixels per meter. De grootte van de textuur map kan verschillen, afhankelijk van het aantal en de grootte van de elementen.",
	"panel.skin_pose": "Houding",
	"panel.skin_pose.none": "Geen",
	"panel.skin_pose.natural": "Natuurlijk",
	"panel.skin_pose.walking": "Stappen",
	"panel.skin_pose.crouching": "Hurken",
	"panel.skin_pose.sitting": "Zitten",
	"panel.skin_pose.jumping": "Springen",
	"panel.skin_pose.aiming": "Richten",
	"edit.loop_cut.direction": "Richting",
	"data.texture_mesh": "Textuur Mesh",
	"generic.left": "Links",
	"generic.right": "Rechts",
	"mode.start.quick_setup": "Snelle Opstart",
	"mode.start.keymap": "Toetsenbordindeling",
	"mode.start.quick_setup.more_themes": "Meer...",
	"dialog.resize_texture.animation_frames": "Animatie Frames",
	"dialog.export_emission_map.title": "Exporteer Emissie-map",
	"dialog.export_emission_map.format": "Formaat",
	"dialog.export_emission_map.format.luminance": "Lichtsterkte",
	"dialog.export_emission_map.format.luminance_inverted": "Lichtsterkte Geïnverteerd",
	"dialog.export_emission_map.format.colors": "Kleuren",
	"dialog.export_emission_map.threshold": "Transparantie Drempel",
	"dialog.export_emission_map.round_up": "Rond af op %0 x %1",
	"dialog.export_emission_map.flip_y": "Draai de Y-As Om",
	"dialog.select.type": "Element Type",
	"dialog.create_texture.max_edge_angle": "Randhoek Drempel",
	"dialog.create_texture.max_edge_angle.desc": "De maximale hoek tussen twee vlakken waarbij ze nog steeds worden gecombineerd",
	"dialog.create_texture.max_island_angle": "Eilandhoek Drempel",
	"dialog.create_texture.max_island_angle.desc": "De maximale hoek die in hetzelfde UV-eiland kan worden gecombineerd",
	"settings.mobile_panel_side": "Mobieltje Paneelzijde",
	"settings.mobile_panel_side.desc": "Selecteer aan welke kant van het scherm panelen worden weergegeven bij gebruik van Blockbench in landschapsoriëntatie",
	"settings.obj_face_export_mode": "OBJ Face Export Modus",
	"settings.obj_face_export_mode.desc": "Kies of the OBJ exporteur alle vlakken moeten omzetten in drie- of vierhoeken",
	"settings.obj_face_export_mode.both": "Standaard",
	"settings.obj_face_export_mode.tris": "Converteer naar Driehoeken",
	"settings.obj_face_export_mode.quads": "Converteer naar Vierhoeken",
	"action.seam_tool": "Naad Gereedschap",
	"action.seam_tool.desc": "Gereedschap om de UV naad te definiëren op mesh randen",
	"action.resolve_group": "Los Groep op",
	"action.resolve_group.desc": "Los de groep op, maar behoud de plaats van de kinderen",
	"action.move_to_group": "Verplaats naar Groep",
	"action.move_to_group.desc": "Verplaats alle geselecteerde elementen naar een andere omlijning groep",
	"action.select_seam": "Selecteer UV Naad",
	"action.select_seam.desc": "Selecteer de UV naad modus voor de geselecteerde randen",
	"action.select_seam.auto": "Auto",
	"action.select_seam.join": "Voeg Samen",
	"action.select_seam.divide": "Verdeel",
	"action.adjust_brightness_contrast": "Pas Helderheid & Contrast Aan...",
	"action.adjust_brightness_contrast.desc": "De helderheid en het contrast van de geselecteerde textuur aanpassen",
	"action.adjust_saturation_hue": "Pas Verzadiging en Tint Aan...",
	"action.adjust_saturation_hue.desc": "De verzadiging en tint van de geselecteerde textuur aanpassen",
	"action.invert_colors": "Inverteer Kleuren",
	"action.invert_colors.desc": "Inverteer alle kleuren van de geselecteerde textuur",
	"action.adjust_curves": "Pas Curves Aan...",
	"action.adjust_curves.desc": "Pas de helderheidscurves van de geselecteerde textuur aan",
	"action.flip_texture_x": "Draai Textuur Horizontaal Om",
	"action.flip_texture_y": "Draai Textuur Verticaal Om",
	"action.resize_texture": "Herschaal Textuur...",
	"action.view_mode.uv": "UV Voorvertoning",
	"action.append_to_template": "Voeg Elementen Toe aan Sjabloon...",
	"action.append_to_template.desc": "Voegt de huidig geselecteerde elementen toe aan de textuur sjabloon",
	"action.move_texture_with_uv": "Textuur verplaatsen met UV",
	"action.move_texture_with_uv.desc": "Verplaats de textuur van het vlak mee bij het verslepen van UV-vlakken",
	"action.timeline_setups": "Tijdlijn Instellingen",
	"action.save_timeline_setup": "Tijdlijn Instellingen Opslaan...",
	"action.save_timeline_setup.desc": "Sla een preset op voor de momenteel geselecteerde animatoren en kanalen",
	"menu.texture": "Textuur",
	"menu.texture.render_mode.default": "Standaard",
	"menu.texture.merge_onto_texture": "Samenvoegen op Textuur Hierboven",
	"menu.animation.unload": "Lossen",
	"panel.timeline": "Tijdlijn",
	"action.pan_tool": "Pan Gereedschap",
	"action.pan_tool.desc": "Gereedschap om te navigeren in de viewport en textuur-editor",
	"mode.start.recent.favorite": "Markeer als Favoriet",
	"mode.start.info": "Info",
	"mode.start.target": "Doel",
	"mode.start.start": "Start",
	"mode.start.create_new": "Maak Nieuw Model",
	"mode.start.format.informations": "Goed om weten:",
	"mode.start.format.resources": "Hulpbronnen:",
	"format.free.info.meshes": "In dit formaat kan u low-poly modellen maken met kubussen en aangepaste meshes.",
	"format.free.info.limitation": "Modellen kunnen niet worden geladen in spellen die speciale formaten nodig hebben, zoals Minecraft.",
	"format.skin.info.skin": "Dit formaat is ontworpen om Minecraft-skins en entiteittexturen te maken.",
	"format.skin.info.model": "Het model kan niet worden gewijzigd. Om wijzigingen in het model aan te brengen, moet u eerst converteren naar een ander formaat via **Bestand** > **Converteer Project**.",
	"format.java_block.info.rotation": "De rotaties zijn beperkt tot stappen van 22.5 graden en één as per element",
	"format.java_block.info.size": "Het model is beperkt tot een grootte van 3 bij 3 bij 3 blokken. Weergave-instellingen kunnen itemmodellen echter groter maken",
	"format.java_block.info.animation": "Dit formaat ondersteunt geen animaties in vanilla Minecraft. Als u een mod maakt, kan u GeckoLib gebruiken om modellen te animeren. Zo niet, dan is de enige manier om te animeren het model uit te wisselen met commando's of geanimeerde texturen.",
	"format.bedrock.info.textures": "Elk model kan slechts één textuur hebben",
	"format.bedrock_block": "Bedrock Blok",
	"format.bedrock_block.desc": "Blokmodel voor Minecraft Bedrock Editie",
	"format.modded_entity.info.integer_size": "De grootte van de individuele kubussen is beperkt tot gehele getallen.",
	"format.modded_entity.info.format": "Modellen worden geschreven in Java-code in plaats van specifieke gegevensstructuren zoals alle andere Blockbench-exportformaten.",
	"format.optifine_entity.info.optifine_required": "Gebruikers zonder OptiFine zien het model niet.",
	"format.optifine_entity.info.pivots": "De botscharnieren zijn vergrendeld, dus het is een goed idee ze ongemoeid te laten.",
	"format_category.low_poly": "Low-Poly",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Andere",
	"format_category.loaders": "Laders",
	"message.recover_backup.recover": "Herstel",
	"message.invalid_characters.title": "Ongeldig Pad",
	"message.invalid_characters.message": "Het pad van het geïmporteerde bestand bevat ongeldige tekens, hoofdletters of witte spaties. De ondersteunde tekens zijn: %0",
	"dialog.share_model.thumbnail": "Miniatuur",
	"dialog.skin.high_res_texture": "Houd er rekening mee dat skins met de geselecteerde resolutie niet werken als gewone Minecraft-skins. Selecteer een lagere resolutie.",
	"settings.allow_display_slot_mirror": "Spiegeling van Weergaveslot Toestaan",
	"settings.allow_display_slot_mirror.desc": "Toestaan ​​dat weergaveslots voor modellen van Java-items worden gespiegeld. WAARSCHUWING: dit werkt alleen in Minecraft 1.14 of eerder, of in speciale gevallen.",
	"action.switch_tabs": "Schakel tussen Tabbladen",
	"action.switch_tabs.desc": "Schakel tussen geopende tabbladen. Houd shift ingedrukt om in de tegenovergestelde richting te fietsen.",
	"action.unselect_all": "Alles Deselecteren",
	"action.save_palette": "Sla Palet Op...",
	"action.save_palette.desc": "Bewaar het huidige kleurenpalet in Blockbench voor later gebruik",
	"action.keyframe_column_create": "Maak Keyframe Kolom",
	"action.keyframe_column_create.desc": "Toets alle kanalen in de tijdlijn in op de huidige tijdcode, als ze al keyframes hebben",
	"action.keyframe_column_select": "Selecteer Keyframe Kolom",
	"action.keyframe_column_select.desc": "Selecteer alle hoofdframes in de tijdlijn langs een kolom onder de afspeelkop",
	"menu.uv": "UV",
	"menu.keyframe": "Keyframe",
	"menu.palette.load.update": "Update Palet",
	"menu.palette.load.update.desc": "Werkt dit palet bij met de kleuren van het huidige Blockbench-palet",
	"menu.timeline_marker.set_time": "Stel Tijd In...",
	"uv_editor.scale_uv": "Schaal UV",
	"action.preview_scene": "Toon Scene",
	"action.preview_scene.desc": "Wijzig de voorbeeldscène van het model",
	"preview_scene.minecraft_overworld": "Minecraft Overworld",
	"preview_scene.minecraft_nether": "Minecraft Nether",
	"preview_scene.minecraft_end": "Minecraft End",
	"dialog.project.modded_entity_flip_y": "Draai de Y-As Om",
	"preview_scene.studio": "Studio",
	"format.image": "Afbeelding",
	"modifier_actions.set_copy_source": "Kopieerbron Instellen",
	"message.load_images.title": "Laad Afbeeldingen",
	"message.load_images.edit_image": "Pas Afbeelding Aan",
	"dialog.add_primitive.align_edges": "Randen Uitlijnen",
	"dialog.flip_animation.show_in_timeline": "Toon gewijzigde botten in tijdlijn",
	"settings.default_cube_size": "Kubus Grootte",
	"settings.default_cube_size.desc": "Stel de standaard grootte in van een nieuwe kubus",
	"settings.uniform_keyframe": "Uniforme Schaal Keyframes",
	"settings.uniform_keyframe.desc": "Stel schaal hoofdframes standaard in op uniform schalen",
	"settings.nearest_rectangle_select": "Rechthoekselectie: Dichtstbijzijnde rand",
	"settings.nearest_rectangle_select.desc": "Snap rechthoekige selecties naar de dichtstbijzijnde pixelrand, zoals in GIMP, in plaats van hele pixels.",
	"settings.pick_color_opacity": "Kies Ondoorzichtigheid",
	"settings.pick_color_opacity.desc": "Kies de ondoorzichtigheid met de Kleur Pipet en stel deze in als penseeldekking",
	"settings.paint_with_stylus_only": "Verf Alleen met Stylus",
	"settings.paint_with_stylus_only.desc": "Gebruik de stylus alleen om te schilderen, reserveer muis- of aanraakinvoer voor navigatie.",
	"action.copy_brush_mode": "Kopieer Kwast Modus",
	"action.copy_brush_mode.copy": "Kopieer",
	"action.copy_brush_mode.pattern": "Patroon",
	"action.copy_brush_mode.sample": "Sample",
	"action.brush_shape": "Kwast Vorm",
	"action.brush_shape.square": "Vierkant",
	"action.brush_shape.circle": "Cirkel",
	"action.blend_mode": "Meng Modus",
	"action.blend_mode.default": "Standaard",
	"action.blend_mode.set_opacity": "Stel Ondoorzichtigheid In",
	"action.blend_mode.color": "Kleur",
	"action.blend_mode.behind": "Achter",
	"action.blend_mode.multiply": "Vermenigvuldig",
	"action.blend_mode.divide": "Deel door",
	"action.blend_mode.add": "Voeg Toe",
	"action.blend_mode.subtract": "Trek Af",
	"action.blend_mode.screen": "Scherm",
	"action.blend_mode.overlay": "Overlay",
	"action.blend_mode.hard_light": "Hard Licht",
	"action.blend_mode.difference": "Verschil",
	"action.copy_brush": "Kopieer Kwast",
	"action.copy_brush.desc": "Kwast om delen van je textuur te klonen of patronen te tekenen. Houd Ctrl ingedrukt en klik om een kopieerbron te selecteren.",
	"action.validator_window": "Toon Problemen met Model...",
	"action.validator_window.desc": "Opent de validator, die problemen met het huidige model opsomt.",
	"action.cancel_gif": "Annuleer GIF",
	"menu.text_edit.copy_vector": "Kopieer Vector",
	"menu.brush_presets.dialog": "Kwast Presets...",
	"menu.brush_presets.pixel_brush": "Pixel Kwast",
	"menu.brush_presets.smooth_brush": "Vloeiende Kwast",
	"menu.texture.edit_in_blockbench": "Wijzig in Blockbench",
	"menu.mirror_painting.axis": "As",
	"menu.mirror_painting.axis.desc": "Selecteer langs welke as verfstroken gespiegeld zullen worden",
	"menu.mirror_painting.global": "Globale Symmetrie",
	"menu.mirror_painting.global.desc": "Spiegelschilderen op het model in de globale ruimte ingeschakeld",
	"menu.mirror_painting.local": "Lokale Symmetrie",
	"menu.mirror_painting.local.desc": "Spiegelschilderen in de lokale ruimte voor elk element mogelijk maken",
	"menu.mirror_painting.texture_frames": "Herhaal op Geanimeerde Textuur Kaders",
	"menu.mirror_painting.texture_frames.desc": "Verfstreken spiegelen aan elk frame van geanimeerde texturen",
	"format.bedrock_block.info.size_limit": "De totale grootte van een blok is beperkt tot 30 pixels in alle dimensies. De grens kan in alle richtingen 7 pixels van het midden van het blok verwijderd zijn.",
	"format.bedrock_block.info.textures": "Meerdere texturen kunnen worden toegepast op verschillende kubussen in Blockbench, maar vereisen extra instellingen in het behavior pack om correct te werken in het spel.",
	"format.image.desc": "Bewerk afbeeldingen in de 2D-beeldeditor",
	"generic.delete_all": "Verwijder Alles",
	"message.child_model_only.open": "Open Ouder",
	"message.child_model_only.open_with_textures": "Open Ouder en Adopteer Texturen",
	"dialog.project.credit": "Credit",
	"dialog.convert_project.create_copy": "Maak Kopie",
	"dialog.texture.frame_time": "Frame Tijd",
	"dialog.texture.frame_time.desc": "Stel in hoe lang elk frame zichtbaar is, in tikken. Elke tik is 1/20ste van een seconde.",
	"dialog.texture.frame_interpolate": "Interpoleer",
	"dialog.texture.frame_interpolate.desc": "Interpoleer tussen animatieframes door cross-fading naar het volgende frame",
	"dialog.texture.frame_order_type": "Herhaal Modus",
	"dialog.texture.frame_order_type.loop": "Herhaal",
	"dialog.texture.frame_order_type.backwards": "Herhaal Achterstevoren",
	"dialog.texture.frame_order_type.back_and_forth": "Heen-en-Weer",
	"dialog.texture.frame_order_type.custom": "Aangepaste Volgorde",
	"dialog.texture.frame_order": "Frame Volgorde",
	"dialog.texture.frame_order.desc": "Stel een aangepaste framevolgorde in door frame-indexen in een nieuwe volgorde weer te geven. Frame-indexen beginnen bij 0 bij het eerste frame.",
	"dialog.select.mode": "Modus",
	"dialog.select.mode.new": "Nieuwe Selectie",
	"dialog.select.mode.add": "Voeg toe aan Selectie",
	"dialog.select.mode.remove": "Verwijder uit Selectie",
	"dialog.select.mode.in_selection": "Selecteer enkel uit Selectie",
	"dialog.predicate_overrides.model": "Model",
	"dialog.predicate_overrides.predicates": "Voorgangers",
	"dialog.predicate_overrides.variants": "Varianten",
	"dialog.predicate_overrides.start_value": "Start",
	"dialog.predicate_overrides.add_override": "Voeg Overschrijving Toe",
	"dialog.predicate_overrides.add_predicate": "Voeg Voorganger Toe",
	"dialog.predicate_overrides.generate_overrides": "Genereer Overschrijvingen",
	"dialog.predicate_overrides.confirm_delete": "Bent u zeker dat u alle overschrijvingen wilt verwijderen?",
	"dialog.predicate_overrides.predicate.angle": "Kompashoek",
	"dialog.predicate_overrides.predicate.blocking": "Blokkeert",
	"dialog.predicate_overrides.predicate.broken": "Is Gebroken",
	"dialog.predicate_overrides.predicate.cast": "Is Gecast",
	"dialog.predicate_overrides.predicate.cooldown": "Cooldown",
	"dialog.predicate_overrides.predicate.damage": "Schade",
	"dialog.predicate_overrides.predicate.damaged": "Is Beschadigd",
	"dialog.predicate_overrides.predicate.lefthanded": "Is Linkshandig",
	"dialog.predicate_overrides.predicate.pull": "Trek Hoeveelheid",
	"dialog.predicate_overrides.predicate.pulling": "Trekt",
	"dialog.predicate_overrides.predicate.charged": "Is Geladen",
	"dialog.predicate_overrides.predicate.firework": "Heeft Vuurwerk",
	"dialog.predicate_overrides.predicate.throwing": "Klaar om te Gooien",
	"dialog.predicate_overrides.predicate.time": "Tijdstip",
	"dialog.predicate_overrides.predicate.custom_model_data": "Aangepaste Modelgegevens",
	"dialog.predicate_overrides.predicate.level": "Lichtniveau",
	"dialog.predicate_overrides.predicate.filled": "Bundel Vulniveau",
	"dialog.predicate_overrides.predicate.tooting": "Toeteren",
	"settings.model_export_scale": "Model Export Schaal",
	"settings.model_export_scale.desc": "Factor waarmee de schaal van geëxporteerde glTF-, DAE- en FBX-modellen wordt verkleind. De standaardwaarde is 16, wat 16 Blockbench-eenheden converteert naar 1 meter in de export.",
	"action.export_fbx": "Exporteer FBX Model",
	"action.export_fbx.desc": "Exporteer model en animaties als .fbx-bestand voor gebruik in andere 3D-applicaties en game engines",
	"action.center_lateral": "Centreer Lateraal",
	"action.center_lateral.desc": "Centreer de geselecteerde elementen op de X- en Z-as",
	"action.adjust_opacity": "Pas Ondoorzichtigheid Aan...",
	"action.adjust_opacity.desc": "Pas ondoorzichtigheid aan van de geselecteerde textuur",
	"action.rotate_texture_cw": "Draai Textuur met de Klok Mee",
	"action.rotate_texture_ccw": "Draai Textuur tegen de Klok In",
	"action.predicate_overrides": "Wijzig Voorganger Overschrijvingen...",
	"action.predicate_overrides.desc": "Selecteer modellen om dit model te overschrijven op basis van geselecteerde voorwaarden",
	"action.auto_set_cullfaces": "Stel Cullfaces Automatisch In",
	"action.auto_set_cullfaces.desc": "Automatisch cullfaces genereren om vlakken te verbergen als ze bedekt worden door het naburige blok.",
	"menu.texture.edit_externally": "Extern Bewerken",
	"menu.mirror_painting.texture": "2D Editor Symmetrie",
	"menu.mirror_painting.texture.desc": "Spiegelschilderen in 2D ruimte op de afbeelding of textuur mogelijk maken",
	"menu.animator.rotation_global": "Draaien in Globale Ruimte",
	"uv_editor.face_properties": "Vlak Eigenschappen",
	"uv_editor.face_properties.material_instance": "Materiaal Instanties",
	"uv_editor.tint.info": "Tint kan worden ingeschakeld op een vlak om Minecraft te vertellen het te kleuren. In vanille kan tint alleen worden gebruikt door specifieke blokken zoals bladeren en redstone dust, en kan alleen een waarde van 0 hebben.",
	"uv_editor.cullface.info": "Het inschakelen van cullface vertelt een vlak op een blok om te ontrenden als een ander vol blok ernaast wordt geplaatst in de opgegeven richting in je Minecraft wereld. Dit kan gebruikt worden om de prestaties te optimaliseren.",
	"uv_editor.material_instance.info": "Materiaal instanties kunnen worden ingesteld op een door de gebruiker gedefinieerde naam. Die naam kan worden gebruikt in het JSON-bestand in het gedragspakket om een bepaalde textuur en materiaal aan het gezicht toe te wijzen.",
	"display.reference.frame_invisible": "Item Frame (Onzichtbaar)",
	"data.settings_profile": "Profiel",
	"message.display_skin.invalid_name": "Kan Minecraft-account met de naam \"%0\" niet vinden.",
	"dialog.load_plugins_from_query.title": "Laad Plugins",
	"dialog.load_plugins_from_query.text": "U heeft een link gebruikt waarvoor plugins geïnstalleerd moeten worden. Wilt u ze installeren?",
	"dialog.select_model.title": "Selecteer Model",
	"dialog.select_model.bones": "Botten",
	"dialog.select_model.cubes": "Kubussen",
	"dialog.settings.create_profile": "Maak Profiel...",
	"settings_profile.confirm_delete": "Bent u zeker dat u het geselecteerde profiel wilt verwijderen?",
	"settings_profile.condition.type.selectable": "Manueel Selecteerbaar",
	"settings.interface_mode": "UI Modus",
	"settings.interface_mode.desc": "Interface modus. Herstart Blockbench om de wijzigingen toe te passen",
	"settings.interface_mode.auto": "Automatisch",
	"settings.interface_mode.desktop": "Bureaublad",
	"settings.interface_mode.mobile": "Mobieltje",
	"settings.paint_through_transparency": "Verf Door Transparantie",
	"settings.paint_through_transparency.desc": "Verf door transparante pixels wanneer alfakanaal vergrendelen is ingeschakeld",
	"action.tab_overview": "Tabblad Overzicht",
	"action.tab_overview.desc": "Bekijk alle geopende tabbladen in een raster en spring naar één",
	"action.slider_color_red": "Kleur Rood",
	"action.slider_color_green": "Kleur Groen",
	"action.slider_color_blue": "Kleur Blauw",
	"action.add_animation_controller": "Animatie Controller Toevoegen",
	"action.add_animation_controller.desc": "Maak een Lege Animatiecontroller",
	"action.animation_controller_preview_mode": "Controller Voorbeeld",
	"action.animation_controller_preview_mode.paused": "Gepauzeerd",
	"action.animation_controller_preview_mode.manual": "Handmatig Voorbeeld",
	"action.animation_controller_preview_mode.play": "Auto Afspelen",
	"action.keyframe_interpolation.bezier": "Bézier",
	"action.keyframe_bezier_linked": "Koppel Bézier Handgrepen",
	"action.keyframe_bezier_linked.desc": "Verbind de rechter en linker keyframe bézier-handgreep",
	"action.reset_keyframe_handles": "Reset Keyframe Handgrepen",
	"action.reset_keyframe_handles.desc": "Reset de bézierhandles van de geselecteerde keyframes",
	"action.looped_animation_playback": "Lus Afspelen",
	"action.looped_animation_playback.desc": "Voorvertoning van animaties in een oneindige lus",
	"timeline.bind_to_actor": "Binden aan Actor",
	"animation_controllers.select_preset": "Selecteer een controller preset...",
	"animation_controllers.state.animations": "Animaties",
	"animation_controllers.state.particles": "Deeltjes",
	"animation_controllers.state.sounds": "Geluiden",
	"animation_controllers.state.on_entry": "Bij Binnenkomen",
	"animation_controllers.state.on_exit": "Bij Weggaan",
	"animation_controllers.state.transitions": "Transities",
	"animation_controllers.state.condition": "Conditie",
	"animation_controllers.state.blend_transition": "Meng Tijd",
	"animation_controllers.state.shortest_path": "Meng via Kortste Pas",
	"animation_controllers.state.edit_transition": "Wijzig Transitie",
	"menu.color_picker.picker_type": "Kiezer Type",
	"menu.color_picker.picker_type.square": "Vierkant",
	"menu.color_picker.picker_type.wheel": "Wiel",
	"menu.color_picker.slider_mode": "Slider Modus",
	"menu.color_picker.slider_mode.hsv": "Tint, Verzadiging, Waarde",
	"menu.color_picker.slider_mode.rgb": "Rood, Groen, Blauw",
	"menu.texture.render_mode.additive": "Additief",
	"panel.color.picker_options": "Kleur Pipet Opties",
	"panel.animation_controllers": "Animatie Controller",
	"display.preset.armor_stand": "Grond (Harnashouder)",
	"data.file_path": "Bestandslocatie",
	"dialog.extrude.orientation": "Oriëntatie",
	"dialog.extrude.orientation.upright": "Rechtop",
	"dialog.extrude.orientation.flat": "Plat",
	"dialog.scale.box_uv_warning": "Het schalen van een Box UV-model kan de UV van uw model breken. Probeer in plaats daarvan uw model extern te schalen, of schakel over op Per-vlak UV Mode in Bestand > Project.",
	"dialog.create_gif.format": "Formaat",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "PNG Sequentie",
	"dialog.create_gif.pixelate": "Pixelate",
	"dialog.create_gif.bg_image": "Achtergrond Afbeelding",
	"dialog.create_gif.turn.desc": "Draai het model tijdens het opnemen. Gebruik negatieve waarden om het model rechtsom te draaien. Een waarde van 60 komt overeen met één rotatie per seconde.",
	"settings_profile.condition": "Voorwaarde",
	"settings_profile.condition.type.file_path.desc": "Gebruik Regular Expression syntax om het bestandspad van het huidige project te matchen. Gebruik schuine streep voor mappen",
	"settings.only_selected_bezier_handles": "Toon Alleen Geselecteerde Bézier Handgrepen",
	"settings.only_selected_bezier_handles.desc": "Handvatten van bézier-hoofdframes verbergen die momenteel niet zijn geselecteerd",
	"settings.embed_textures": "Sluit Texturen In",
	"settings.embed_textures.desc": "Inhoud van textuurbestanden insluiten in .bbmodel-bestanden",
	"action.selection_mode.cluster": "Kluster",
	"dialog.copied_to_clipboard": "Kopieer naar klembord",
	"data.reference_image": "Referentiebeeld",
	"message.delete_reference_image": "Weet u zeker dat u dit referentiebeeld wilt verwijderen? Dit kan niet ongedaan gemaakt worden.",
	"message.add_reference_image.message": "Selecteer waar u het referentiebeeld wilt laden",
	"message.add_reference_image.project": "Voeg toe aan dit project",
	"message.add_reference_image.app": "Voeg toe aan alle projecten",
	"message.import_particle_texture.import": "Importeer Deeltjestextuur",
	"message.import_particle_texture.message": "Wilt u een textuurbestand importeren om te gebruiken voor uw deeltje?",
	"message.save_codec_selector.title": "Sla Modelformaat Op",
	"message.save_codec_selector.message": "Selecteer een formaat om het model in op te slaan.",
	"message.save_codec_selector.project_file": "Blockbench Project (.bbmodel)",
	"message.save_codec_selector.both": "Beiden",
	"message.display_skin.username": "Gebruikersnaam (Java)",
	"message.palette_locked": "Het palet is vergrendeld",
	"dialog.project.default_uv_mode": "Standaard UV Modus",
	"dialog.project.default_uv_mode.description": "Standaard UV-modus van het project. De UV-modus is ook per kubus te wijzigen.",
	"dialog.export_options.title": "Exporteer Opties",
	"dialog.edit_texture.preview": "Voorvertoning",
	"dialog.proportional_editing.range": "Bereik",
	"dialog.proportional_editing.falloff": "Afval",
	"dialog.proportional_editing.falloff.linear": "Lineair",
	"dialog.proportional_editing.falloff.hermite_spline": "Vloeiend",
	"dialog.proportional_editing.falloff.constant": "Constant",
	"dialog.proportional_editing.selection": "Selectie",
	"dialog.proportional_editing.selection.linear": "Lineaire Afstand",
	"dialog.proportional_editing.selection.connections": "Connecties",
	"dialog.mirror_painting_texture_center.middle": "Midden",
	"dialog.mirror_painting_texture_center.custom": "Aangepast",
	"dialog.settings.reset_to_default": "Herstel naar Standaard",
	"keybindings.item.num_slider.increase": "Verhoog",
	"keybindings.item.num_slider.decrease": "Verlaag",
	"settings.always_show_splash_art": "Toon Altijd Splash Art",
	"settings.always_show_splash_art.desc": "Geef de splash-art altijd weer op het startscherm",
	"action.slider_palette_color": "Paletkleur Wisselen",
	"action.slider_palette_color.desc": "Schakel tussen de kleuren in het palet",
	"action.proportional_editing": "Proportioneel Bewerken",
	"action.proportional_editing.desc": "Beïnvloed proportioneel omringende vertices bij het bewerken van delen van een mesh",
	"action.limit_to_palette": "Beperk tot Palet",
	"action.limit_to_palette.desc": "Beperkt de kleuren van de textuur tot die in het huidig ​​geladen palet",
	"action.edit_reference_images": "Bewerk Referentiebeeld",
	"action.edit_reference_images.desc": "Schakel de referentiebeeldmodus in om referentiebeelden en blauwdrukken toe te voegen of te bewerken",
	"action.add_reference_image": "Voeg Referentiebeeld Toe",
	"action.reference_image_from_clipboard": "Referentiebeeld van klembord",
	"action.reference_image_list": "Referentiebeelden",
	"action.connect_uv_faces": "Verbind UV Vlakken",
	"action.connect_uv_faces.desc": "Verbind de geselecteerde UV-gezichten met het laatst geselecteerde UV-gezicht",
	"action.merge_uv_vertices": "Voeg UV Vertices Samen",
	"action.merge_uv_vertices.desc": "Klik de eerste geselecteerde UV-vertices vast op de laatst geselecteerde UV-vertices",
	"action.bedrock_animation_mode": "Bedrock Animatie Modus",
	"action.bedrock_animation_mode.desc": "Selecteer de modus om animaties voor Minecraft: Bedrock Edition in te bewerken",
	"action.bedrock_animation_mode.entity": "Entiteit",
	"action.bedrock_animation_mode.attachable_first": "Item 1st Person",
	"action.bedrock_animation_mode.attachable_third": "Item 3rd Person",
	"timeline.amplify": "Versterk",
	"menu.options": "Opties...",
	"menu.palette.lock_palette": "Palet Vergrendelen",
	"menu.uv.export": "Exporteer UV Mapping",
	"menu.uv.flip_x": "Spiegel X",
	"menu.uv.flip_y": "Spiegel Y",
	"menu.mirror_painting.enabled": "Ingeschakeld",
	"reference_image.position": "Positie",
	"reference_image.size": "Grootte",
	"reference_image.rotation": "Rotatie",
	"reference_image.opacity": "Ondoorzichtigheid",
	"reference_image.visibility": "Zichtbaarheid",
	"reference_image.clear_mode": "Doorzichtige Modus",
	"reference_image.layer": "Laag",
	"reference_image.layer.background": "Achter Model",
	"reference_image.layer.viewport": "Boven Model",
	"reference_image.layer.float": "Boven Interface",
	"reference_image.scope": "Bereik",
	"reference_image.scope.project": "Enkel dit project",
	"reference_image.scope.global": "Alle projecten",
	"reference_image.enabled_modes": "Ingeschakeld in Modi",
	"codec.common.encoding": "Codering",
	"codec.common.armature": "Exporteer Groepen als Armature",
	"codec.common.export_animations": "Exporteer Animaties",
	"codec.common.embed_textures": "Sluit Texturen In",
	"preview.center_camera": "Centreer Camera",
	"display.reference.frame_top": "Item Frame Bovenkant",
	"display.reference.frame_top_invisible": "Item Frame Bovenkant (Onzichtbaar)",
	"action.proportional_editing_range": "Proportioneel Bewerkingsbereik",
	"action.proportional_editing_range.desc": "Pas het bereik aan voor proportioneel bewerken",
	"action.toggle_all_reference_images": "Toon/Verberg Alle Referentiebeelden",
	"action.toggle_all_reference_images.desc": "Schakel de zichtbaarheid van alle referentiebeelden tegelijk",
	"action.add_animation_controller_state": "Voeg Animatie Controller Toestand Toe",
	"action.add_animation_controller_state.desc": "Voeg een nieuwe toestand toe aan de animatie controller",
	"menu.slider.round_value": "Rond Waarde Af",
	"texture.error.too_large": "Resolutie overschrijdt het maximum van %0",
	"dialog.copy_to_clipboard": "Kopieer naar klembord",
	"dialog.open_url": "Open URL",
	"reference_image.image": "Afbeelding",
	"uv_editor.rotate_uv": "UV Draaien",
	"generic.error": "Fout",
	"projects.start_screen": "Startscherm",
	"message.invalid_link.message": "Het gedeelde model \"%0\" dat je probeert te laden is verlopen of invalide.",
	"message.plugin_dependencies.title": "Plugin Afhankelijkheden",
	"message.plugin_dependencies.message1": "De plugin heeft deze afhankelijkheden nodig:",
	"message.plugin_dependencies.message1_update": "Plugin %0 is bijgewerkt en heeft nu deze afhankelijkheden nodig:",
	"message.plugin_dependencies.message2": "Wil je ze installeren om verder te gaan?",
	"message.plugin_dependencies.invalid": "Helaas kan de plugin niet worden geïnstalleerd, het heeft een ongeldige afhankelijkheid:",
	"message.preview_scene_load_failed": "Niet gelukt om voorbeeld scene te laden. Check je internet verbinding.",
	"dialog.convert_project.text1": "Zet het project om naar een ander formaat.",
	"dialog.convert_project.text2": "Gebruik omzetting op eigen risico. Formaten hebben verschillende functies en beperkingen, omzetten zal dus in sommige gevallen delen van je project breken.",
	"dialog.convert_project.text3": "Je kan omzetten niet ongedaan maken, dat is waarom er standaard een kopie zal worden aangemaakt.",
	"dialog.unsaved_work.title": "Niet-opgeslagen Werk",
	"dialog.unsaved_work.text": "De volgende projecten bevatten niet-opgeslagen veranderingen. Wil je je veranderingen opslaan?",
	"dialog.unsaved_work.discard_all": "Alles Weggooien",
	"dialog.unsaved_work.save_all": "Alles Opslaan",
	"dialog.resize_texture.mode": "Modus",
	"dialog.resize_texture.mode.crop": "Bijsnijden/Vergroten",
	"dialog.resize_texture.mode.scale": "Schaal",
	"dialog.plugins.is_installed": "Geïnstalleerd",
	"dialog.plugins.is_disabled": "Uitgeschakeld",
	"dialog.plugins.disable": "Uitschakelen",
	"dialog.plugins.enable": "Inschakelen",
	"dialog.plugins.dependencies": "Is afhankelijk van:",
	"dialog.view_backups.open_folder": "Open Folder",
	"dialog.share_model.reference_images": "Referentiebeeld Bijvoegen",
	"dialog.share_model.too_large": "Uploaden is mislukt: Model is te groot",
	"dialog.share_model.too_large_references": "Uploaden is mislukt: Model is te groot. Probeer het zonder referentiebeeld.",
	"settings.stretch_linked": "Link Rekken",
	"settings.stretch_linked.desc": "Rek de kubus uit in alle richtingen met dezelfde waarde",
	"settings.grids": "Toon Rasters",
	"settings.grids.desc": "Toon of verberg alle 3D rasters",
	"settings.double_click_switch_tools": "Switch Tools on Double Click",
	"settings.double_click_switch_tools.desc": "Double click the viewport to switch between tools",
	"settings.outlines_in_paint_mode": "Selection Outlines in Paint Mode",
	"settings.outlines_in_paint_mode.desc": "Display element selection outlines while in paint mode",
	"settings.json_indentation": "JSON Indentation",
	"settings.json_indentation.desc": "Indentation style for exported JSON files",
	"settings.json_indentation.tabs": "Tabs",
	"settings.json_indentation.spaces_4": "Spaces: 4",
	"settings.json_indentation.spaces_2": "Spaces: 2",
	"action.slider_stretch": "Stretch",
	"action.slider_stretch.desc": "Stretches cubes multiplicatively on the %0 axis without changing the UV",
	"action.view_backups": "View Backups",
	"action.view_backups.desc": "Browse the list of auto-saved project backups",
	"action.search_outliner": "Search Outliner",
	"action.search_outliner.desc": "Search for specific element names in the outliner",
	"action.mirror_modeling": "Mirror Modeling",
	"action.mirror_modeling.desc": "Enable Mirror Modeling on the X axis. All changes you make in the viewport will be reflected to the other side, unless specifically disabled on the element.",
	"action.allow_element_mirror_modeling": "Allow Mirror Modeling",
	"action.allow_element_mirror_modeling.desc": "Choose whether the selected elements can be affected by mirror modeling",
	"action.switch_face_crease": "Switch Face Crease",
	"action.switch_face_crease.desc": "Switch in which direction the quad folds in the middle",
	"action.clear_unused_texture_space": "Clear Unused Texture Space",
	"action.clear_unused_texture_space.desc": "Clear parts of the texture that are not UV-mapped to any elements",
	"action.split_screen": "Split Screen",
	"action.split_screen.desc": "Select a viewport split screen mode",
	"action.split_screen.single": "Single",
	"action.split_screen.double_horizontal": "Double Horizontal",
	"action.split_screen.double_vertical": "Double Vertical",
	"action.split_screen.quad": "Quad",
	"action.split_screen.triple_left": "Triple Left",
	"action.split_screen.triple_right": "Triple Right",
	"action.split_screen.triple_top": "Triple Top",
	"action.split_screen.triple_bottom": "Triple Bottom",
	"action.uv_project_from_view": "UV Project from View",
	"action.uv_project_from_view.desc": "Automatically generate UVs for the selected faces from the perspective of the 3D view",
	"action.graph_editor_other_graphs": "Display Other Graphs",
	"action.graph_editor_other_graphs.desc": "Whether the graphs of the axes that are not selected are displayed",
	"action.graph_editor_include_other_graphs": "Include Other Graphs",
	"action.graph_editor_include_other_graphs.desc": "Whether the graph editor includes the graphs that are not selected in the view",
	"action.set_ik_source": "Set IK Root",
	"action.set_ik_source.desc": "Select the root bone of the chain that should be moved by this null object via Inverse Kinematics",
	"edit.loop_cut.cuts": "Cuts",
	"panel.element.stretch": "Stretch",
	"preview_scene.minecraft_plains": "Plains",
	"preview_scene.minecraft_cherry_grove": "Cherry Grove",
	"preview_scene.minecraft_snowy_tundra": "Snowy Tundra",
	"preview_scene.minecraft_sunset": "Sunset",
	"preview_scene.minecraft_night": "Night",
	"preview_scene.minecraft_desert": "Desert",
	"preview_scene.minecraft_underwater": "Underwater",
	"preview_scene.minecraft_coral_reef": "Coral Reef",
	"preview_scene.minecraft_lush_cave": "Lush Cave",
	"preview_scene.minecraft_deep_dark": "Deep Dark",
	"generic.navigate_forward": "Forward",
	"generic.navigate_back": "Back",
	"action.element_render_order": "Transparency Render Order",
	"action.element_render_order.default": "Auto",
	"action.element_render_order.behind": "Behind",
	"action.element_render_order.in_front": "In Front",
	"message.installing_update.title": "Update Available",
	"message.installing_update.message": "A new version is ready to be installed. After closing the app, please allow for around %0 seconds before opening Blockbench again or turning off the computer, for the update to be installed.",
	"settings.brush_cursor_2d": "2D Brush Cursor",
	"settings.brush_cursor_2d.desc": "Display an outline around the brush in the 2D workspace",
	"settings.brush_cursor_3d": "3D Brush Cursor",
	"settings.brush_cursor_3d.desc": "Display an outline around the brush in the 3D workspace",
	"settings.cdn_mirror": "Use CDN Mirror",
	"settings.cdn_mirror.desc": "Use the mirror CDN to download plugins. The mirror receives updates faster and works in some regions where the default does not work.",
	"data.layer": "Layer",
	"data.panel": "Panel",
	"generic.confirm_delete": "Are you sure you want to delete this?",
	"format_category.general": "General",
	"modifier_actions.no_uniform_scaling": "Free Scaling",
	"message.texture_refresh_conflict.title": "Conflicting Texture Versions",
	"message.texture_refresh_conflict.message": "The texture file might contain changes that conflict with Blockbench's version",
	"message.texture_refresh_conflict.keep_ours": "Keep Blockbench's version",
	"message.texture_refresh_conflict.keep_theirs": "Load file and discard all changes and layers in Blockbench",
	"message.group_required_to_animate": "You cannot animate this type of element. Create a group or armature to animate it.",
	"dialog.texture.uv_size": "UV Size",
	"dialog.advanced_screenshot.angle_preset": "Angle Preset",
	"dialog.advanced_screenshot.resolution": "Resolution",
	"dialog.advanced_screenshot.zoom_to_fit": "Zoom To Fit",
	"dialog.advanced_screenshot.zoom": "Zoom / Focal Length",
	"dialog.advanced_screenshot.anti_aliasing": "Anti-aliasing",
	"dialog.advanced_screenshot.anti_aliasing.off": "Off",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "Multisampling",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "Supersampling",
	"dialog.advanced_screenshot.show_gizmos": "Show Edit Gizmos",
	"dialog.advanced_screenshot.shading": "Shading",
	"settings.auto_keyframe": "Auto Keyframe",
	"settings.auto_keyframe.desc": "Automatically create a keyframe with default values at the timeline start when transforming the bone at a later point",
	"settings.modded_entity_integer_size": "Modded Entity Integer Size",
	"settings.modded_entity_integer_size.desc": "Limit cube sizes in the Modded Entity format to integers. While floats are technically supported in some versions, integers are much easier to UV-map.",
	"category.layers": "Layers",
	"keybind.paint_secondary_color": "Paint with Secondary Color",
	"action.selection_tool_operation_mode": "Selection Operation Mode",
	"action.selection_tool_operation_mode.create": "New Selection",
	"action.selection_tool_operation_mode.add": "Add to Selection",
	"action.selection_tool_operation_mode.subtract": "Subtract from Selection",
	"action.selection_tool_operation_mode.intersect": "Intersect",
	"action.pixel_perfect_drawing": "Pixel Perfect Drawing",
	"action.pixel_perfect_drawing.desc": "Draw smooth pixel-art lines without double pixels at curves",
	"action.selection_tool": "Selection Tool",
	"action.selection_tool.desc": "Select parts of the image",
	"action.selection_tool.rectangle": "Rectangle",
	"action.selection_tool.ellipse": "Ellipse",
	"action.selection_tool.lasso": "Lasso Select",
	"action.selection_tool.wand": "Magic Wand",
	"action.selection_tool.color": "Same Color",
	"action.move_layer_tool": "Move Layer",
	"action.move_layer_tool.desc": "Move the current layer or selection",
	"action.export_modded_animations": "Export Modded Entity Animations",
	"action.export_modded_animations.desc": "Export animations for a Minecraft Java Edition modded entity model",
	"action.swap_colors": "Swap Colors",
	"action.swap_colors.desc": "Swap the main color with the secondary color",
	"action.apply_mesh_rotation": "Apply Rotation",
	"action.apply_mesh_rotation.desc": "Reset the element rotation of the mesh, and apply it to the geometry instead",
	"action.flip_texture_x.desc": "Flip the texture or layer horizontally",
	"action.flip_texture_y.desc": "Flip the texture or layer vertically",
	"action.rotate_texture_cw.desc": "Rotate the texture or layer clockwise",
	"action.rotate_texture_ccw.desc": "Rotate the texture or layer counter-clockwise",
	"action.crop_texture_to_selection": "Crop Texture to Selection",
	"action.create_empty_layer": "Create Empty Layer",
	"action.enable_texture_layers": "Enable Layers",
	"action.disable_texture_layers": "Disable Layers",
	"action.layer_opacity": "Layer Opacity",
	"action.layer_to_texture_size": "Expand Layer to Texture Size",
	"action.layer_to_texture_size.desc": "Expand the layer to the size of the texture",
	"action.merge_layer_down": "Merge Down",
	"action.merge_layer_down.desc": "Merge into the layer below",
	"action.advanced_screenshot": "Advanced Screenshot...",
	"action.advanced_screenshot.desc": "Take a screenshot of the model with advanced options",
	"action.bake_ik_animation": "Bake Inverse Kinematics",
	"action.bake_ik_animation.desc": "Bake the rotations applied by inverse kinematics into the selected animation",
	"action.save_animation_preset": "Save Animation Preset...",
	"action.save_animation_preset.desc": "Save the selected keyframes as an animation preset",
	"action.animation_onion_skin": "Animation Onion Skin",
	"action.animation_onion_skin.desc": "Display an wireframe view of a different frame in the animation for reference",
	"action.apply_animation_preset": "Apply Animation Preset",
	"action.apply_animation_preset.desc": "Select from a list of animation presets and apply it to the selected bone",
	"menu.brush_presets.pixel_perfect": "Pixel-perfect Brush",
	"panel.layers": "Layers",
	"uv_editor.copy_paste_tool.to_layer": "To New Layer",
	"format.image.new": "Create New Image",
	"format.image.info.summary": "The 2D Image editor lets you create and edit images and pixel art directly in Blockbench, without the need for an external image editor. Edit images, modify textures, or create your own pixel art!",
	"settings.move_with_selection_tool": "Use Selection Tool to Move Selections",
	"settings.move_with_selection_tool.desc": "Allow the Selection Tool to directly move selections, without having to switch to the Move Layer tool",
	"settings.final_newline": "Final Newline",
	"settings.final_newline.desc": "Insert a newline character at the end of exported files",
	"action.crop_layer_to_selection": "Crop Layer to Selection",
	"action.edit_mode_uv_overlay.desc": "Display the UV map overlay for all elements in edit mode",
	"menu.image": "Image",
	"menu.texture.discard_changes": "Discard Changes",
	"menu.texture.discard_changes.desc": "Discard all unsaved changes and load the latest version from the file",
	"panel.textures.images": "Images",
	"dialog.advanced": "Advanced",
	"dialog.recommended_option": "recommended",
	"modifier_actions.snap_to_center": "Snap to Center",
	"modifier_actions.snap_to_pixels": "Snap to Pixels",
	"message.invalid_format.install_plugin": "Install plugin '%0'",
	"message.plugin_deprecated.message": "Are you sure you want to install this deprecated plugin?",
	"message.plugin_deprecated.install_anyway": "Install Anyway",
	"message.image_editor.not_found": "Could not find the selected image editor. Please select a different option.",
	"message.knife_tool.confirm": "Press %0 or click here to apply Knife Tool",
	"message.knife_tool.skipped_face": "Cannot cut between different faces. Include the edges or vertices between them!",
	"message.optimize_animation.keyframes_removed": "Removed %0 redundant keyframes",
	"message.optimize_animation.nothing_to_optimize": "Found nothing to optimize!",
	"message.duplicate_bone_copy_animation.title": "Copy Animation",
	"message.duplicate_bone_copy_animation.message": "The duplicated bone is animated in %0 animations. Do you want to copy the keyframes over to the new bone?",
	"message.auto_fix_mesh_edit.title": "Auto Fix",
	"message.auto_fix_mesh_edit.revert": "Revert Edit",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Certain vertices have been moved into the same spot. How would you like to proceed?",
	"message.auto_fix_mesh_edit.concave_quads": "One or more quad faces are now concave, which can cause issues in UV-mapping and rendering. Blockbench can automatically fix it for you:",
	"message.auto_fix_mesh_edit.merge_vertices": "Merge Vertices",
	"message.auto_fix_mesh_edit.split_quads": "Split Quads",
	"message.load_images.add_image": "Add Image",
	"dialog.project.modded_entity_entity_class": "Entity Class",
	"dialog.resize_texture.offset": "Offset",
	"dialog.animated_texture_editor.code_reference": "Code Reference",
	"dialog.animated_texture_editor.code_reference.about": "This code to implement the texture animation was generated as a reference and does not necessarily work without modification. Check out the documentation to learn more.",
	"dialog.animated_texture_editor.code_reference.docs": "Documentation",
	"dialog.animated_texture_editor.reframe": "Reframe",
	"dialog.animated_texture_editor.stride": "Frame Size",
	"dialog.animated_texture_editor.frames": "Number of Frames",
	"dialog.animated_texture_editor.add_frame": "Add Frame",
	"dialog.animated_texture_editor.resize_frames": "Resize Frames...",
	"dialog.animated_texture_editor.apply": "Apply",
	"dialog.add_primitive.edge_size": "Edge Size",
	"dialog.change_animation_speed.speed": "Speed",
	"dialog.change_animation_speed.adjust_snapping": "Adjust Snapping",
	"dialog.optimize_animation.selection": "Selection",
	"dialog.optimize_animation.selection.selected_keyframes": "Selected Keyframes",
	"dialog.optimize_animation.selection.selected_animation": "Selected Animation",
	"dialog.optimize_animation.selection.all_animations": "All Animations",
	"dialog.optimize_animation.thresholds": "Threshold values",
	"dialog.import_obj.obj": "OBJ File",
	"dialog.import_obj.mtl": "MTL File",
	"dialog.import_obj.scale": "Scale",
	"layout.thumbnail": "Custom Thumbnail CSS",
	"settings.pixel_grid": "Pixel Grid",
	"settings.pixel_grid.desc": "Show texture pixel grid on elements in edit mode",
	"settings.image_editor_grid_size": "Image Editor Grid Size",
	"settings.image_editor_grid_size.desc": "Size of the large grid in the 2D image editor",
	"settings.ground_plane_double_side": "Ground Plane Double-sided",
	"settings.ground_plane_double_side.desc": "Make the ground plane visible from below",
	"settings.optifine_save_default_texture": "OptiFine JEM: Export selected texture",
	"settings.optifine_save_default_texture.desc": "Export the selected texture as the default texture of the model",
	"action.slider_color_select_threshold": "Color Select Threshold",
	"action.slider_color_select_threshold.desc": "How close the color of a neighboring pixel has to be to get selected by color or wand select",
	"action.stretch_tool": "Stretch",
	"action.stretch_tool.desc": "Tool to select and stretch elements",
	"action.knife_tool": "Knife Tool",
	"action.knife_tool.desc": "Tool to cut mesh faces into smaller pieces",
	"action.duplicate_project": "Duplicate Project",
	"action.duplicate_project.desc": "Creates a copy of the open project",
	"action.transform_space.parent": "Parent",
	"action.transform_pivot_space": "Pivot Transform Space",
	"action.solidify_mesh_selection": "Solidify Faces",
	"action.solidify_mesh_selection.desc": "Solidify the selected faces of the mesh",
	"action.animated_texture_editor": "Flipbook Editor...",
	"action.animated_texture_editor.desc": "Edit the flipbook animation of the selected texture",
	"action.center_individual_pivots": "Center Individual Pivots",
	"action.center_individual_pivots.desc": "Set the pivot point of each selected element to its center",
	"action.uv_cycle": "Cycle UV",
	"action.uv_cycle.desc": "Cycle through the order of UV vertices without changing the UV positions",
	"action.uv_cycle_invert": "Cycle Invert UV",
	"action.uv_cycle_invert.desc": "Reverse the order of UV vertices without changing the UV positions",
	"action.slider_animation_controller_speed": "Controller Playback Speed",
	"action.slider_animation_controller_speed.desc": "The playback speed of animation controllers in percent",
	"action.optimize_animation": "Optimize Animation",
	"action.optimize_animation.desc": "Optimize the current animation and reduce the keyframe count",
	"action.change_animation_speed": "Change Animation Speed...",
	"action.change_animation_speed.desc": "Change the speed of the selected animation",
	"timeline.select_particle_file": "Select Particle File",
	"timeline.select_sound_file": "Select Sound File",
	"menu.cube.texture.default": "Default",
	"menu.texture.particle.clear": "Stop using for Particles",
	"menu.texture.use_as_default": "Set as Default",
	"menu.texture.use_as_default.clear": "Unassign as Default",
	"menu.toolbar.overflow": "Toolbar Overflow",
	"edit.solidify_mesh_selection.thickness": "Thickness",
	"reference_image.sync_to_timeline": "Sync To Timeline",
	"reference_image.toggle_playback": "Play/Pause",
	"dialog.add_primitive.shape.beveled_cuboid": "Beveled Cuboid",
	"dialog.ignore_all": "Ignore All",
	"data.texture_group": "Texture Group",
	"data.animation": "Animation",
	"generic.on": "On",
	"generic.off": "Off",
	"format.free.info.3d_printing": "3D Printing",
	"message.invalid_file.merge_conflict": "The file contains unresolved Git merge conflicts.",
	"dialog.expand_texture_selection.radius": "Amount",
	"dialog.expand_texture_selection.corner": "Corner Shape",
	"dialog.expand_texture_selection.corner.round": "Round",
	"dialog.expand_texture_selection.corner.square": "Square",
	"dialog.expand_texture_selection.corner.manhattan": "Manhattan",
	"dialog.merge_animation.merge_target": "Merge into",
	"keybindings.variation_conflict": "Variation conflicts with the main keybinding",
	"settings.recovery_save_interval": "Recovery Point Save Interval",
	"settings.recovery_save_interval.desc": "Blockbench regularly saves the open project in the background to recover in case of a computer crash. Set the interval in seconds. Set to 0 to disable saving.",
	"settings.save_view_per_tab": "Save View per Tab",
	"settings.save_view_per_tab.desc": "Save the current view angle for each tab separately",
	"settings.inherit_parent_color": "Inherit Parent Color",
	"settings.inherit_parent_color.desc": "Set the marker color of a newly created element to the color of the parent instead of a random color",
	"keybind.preview_select.multi_select": "Multi-select",
	"keybind.preview_select.group_select": "Group-select",
	"keybind.preview_select.loop_select": "Loop-select",
	"action.fill_mode.selection": "Selection",
	"action.fill_mode.selected_elements": "Selected Elements",
	"action.image_tiled_view": "Tiled View",
	"action.image_tiled_view.description": "Enable the tiled view in the 2D editor",
	"action.image_onion_skin_view": "Image Editor Onion Skin",
	"action.image_onion_skin_view.description": "Enable the onion skin view in the 2D editor",
	"action.expand_texture_selection": "Expand Texture Selection",
	"action.expand_texture_selection.desc": "Expand or shrink the texture selection",
	"action.switch_tabs.reverse_order": "Reverse order",
	"action.save_project_incremental": "Save Project With Increment",
	"action.save_project_incremental.desc": "Saves the current model as a project file with an increment (ex: project_2.bbmodel)",
	"action.copy.multiple": "Copy All",
	"action.copy.multiple.desc": "Copy all available data individually",
	"action.paste.multiple": "Paste All",
	"action.randomize_marker_colors": "Randomize Marker Colors",
	"action.cube_light_emission": "Light Emission",
	"action.cube_light_emission.desc": "Change the emissiveness of the selected cubes, as a value between 0 and 15",
	"action.view_mode.colored_solid": "Solid with Marker Colors",
	"action.focus_on_selection.rotate_only": "Rotate only",
	"action.create_texture_group": "Create Texture Group",
	"action.create_texture_group.desc": "Create a group for your textures",
	"action.uv_maximize.all_faces": "Affect all faces",
	"action.retarget_animators": "Retarget Animations",
	"action.retarget_animators.desc": "Select which animator targets which bone or element",
	"action.merge_animation": "Merge Animation",
	"action.merge_animation.desc": "Merge the animation into another animation",
	"action.add_keyframe.reset_values": "With default values",
	"action.set_timeline_range_start": "Set Timeline Range Start",
	"action.set_timeline_range_start.desc": "Set the start point for a custom playback range in the animation timeline",
	"action.set_timeline_range_end": "Set Timeline Range End",
	"action.set_timeline_range_end.desc": "Set the end point for a custom playback range in the animation timeline",
	"action.disable_timeline_range": "Disable Timeline Range",
	"action.disable_timeline_range.desc": "Disable the custom playback range in the animation timeline",
	"menu.texture_group.resolve": "Resolve",
	"menu.image_tiled_view.mirrored": "Mirrored Edges",
	"menu.image_onion_skin_view.frame": "Frames",
	"menu.image_onion_skin_view.frame.last_viewed": "Last Viewed Frame",
	"menu.image_onion_skin_view.frame.previous": "Previous Frame",
	"menu.image_onion_skin_view.frame.next": "Next Frame",
	"menu.image_onion_skin_view.frame.both": "Previous + Next",
	"menu.image_onion_skin_view.display": "Display",
	"menu.image_onion_skin_view.display.pixels": "Smaller Pixels",
	"menu.image_onion_skin_view.display.transparent": "Transparent",
	"menu.image_onion_skin_view.above": "Display Above",
	"menu.animation.reload": "Reload",
	"switches.autouv.alt": "Relative",
	"display.rotation_pivot": "Rotation Pivot",
	"display.scale_pivot": "Scale Pivot",
	"display.reference.fox": "Fox",
	"display.reference.eating": "Eating",
	"preview_scene.sky": "Sky",
	"preview_scene.space": "Space",
	"preview_scene.minecraft_ocean": "Ocean",
	"message.import_palette.selection_only": "Selection only",
	"dialog.blend_transition_edit.ease_in_out": "Ease-in-out (%0)",
	"dialog.blend_transition_edit.generate": "Generate...",
	"dialog.blend_transition_edit.generate.learn_more": "More info and preview",
	"dialog.blend_transition_edit.generate.curve": "Easing Type",
	"dialog.blend_transition_edit.generate.steps": "Keyframes",
	"settings.fps_limit": "FPS Limit",
	"settings.fps_limit.desc": "Limit how many frames per second Blockbench renders. The actual frame rate is limited to what your device can display.",
	"settings.outliner_reveal_on_select": "Reveal Elements on Select",
	"settings.outliner_reveal_on_select.desc": "Reveal elements in the ouliner when selected",
	"settings.java_export_pivots": "Export Pivots in Java block/item models",
	"settings.java_export_pivots.desc": "Save pivot points in Java block/item models on cubes without rotation",
	"animation_controllers.state.blend_transition_curve": "Blend Transition Curve",
	"menu.slider.reset_vector": "Reset Vector",
	"dialog.blend_transition_edit.extended": "Extended Graph",
	"message.screenshot_too_large.title": "Screenshot Resolution Issue",
	"message.screenshot_too_large.message": "The screenshot could not be rendered successfully. Please try again with a lower resolution or without supersampling.",
	"message.rename_elements.numbering": "You can use special characters to generate sequential numbers: % to get the index of the element within its group, $ to get the index within the selection.",
	"generic.edit_externally": "Edit Externally",
	"message.settings_require_restart.title": "Restart Required",
	"message.settings_require_restart.message": "Some settings will only apply after restarting the program.",
	"message.settings_require_restart.restart_now": "Restart Now",
	"message.settings_require_restart.restart_later": "Restart Later",
	"message.classroom_mode.install_plugin": "Cannot install plugins in Classroom Mode",
	"dialog.collection.export_path": "Export Path",
	"dialog.collection.select_all": "Select All",
	"dialog.collection.select_none": "Select None",
	"dialog.collection.add_with_filter": "Add with Filter",
	"dialog.collection.remove": "Remove",
	"dialog.material_config.title": "Material Config",
	"dialog.material_config.color_value": "Color Value",
	"dialog.material_config.mer": "Metal-Emissive-Roughness",
	"dialog.material_config.mer_value": "MER Value",
	"dialog.material_config.depth_type": "Depth Type",
	"dialog.create_texture.disable_mirror_uv": "Disable UV Mirroring",
	"dialog.create_texture.disable_mirror_uv.desc": "Disable the UV Mirror option in Mirror Modeling to preserve separate UVs for each side of the model",
	"dialog.create_gif.turn.sync_to_anim_length": "Sync to animation length",
	"settings.category.controls": "Controls",
	"settings.classroom_mode": "Classroom Mode",
	"settings.classroom_mode.desc": "Restricts functionality such as installing plugins and removes links to social media",
	"settings.antialiasing_bleed_fix": "Fix anti-aliasing bleeding",
	"settings.antialiasing_bleed_fix.desc": "Fixes texture bleeding when using anti-aliasing. Potentially unsupported on older hardware.",
	"settings.tone_mapping": "Tone Mapping",
	"settings.tone_mapping.desc": "Approximation method for displaying high dynamic range on a standard screen for PBR rendering.",
	"settings.audio_scrubbing": "Timline Scrubbing Audio",
	"settings.audio_scrubbing.desc": "Play short previews of the audio while scrubbing through time timeline",
	"settings.viewport_rotate_speed": "Viewport Rotate Speed",
	"settings.viewport_rotate_speed.desc": "Input sensitivity when rotating in the viewport",
	"settings.viewport_zoom_speed": "Viewport Zoom Speed",
	"settings.viewport_zoom_speed.desc": "Input sensitivity when zooming in the viewport",
	"settings.editor_2d_zoom_speed": "2D Editor Zoom Speed",
	"settings.editor_2d_zoom_speed.desc": "Input sensitivity when zooming in the UV and 2D paint editor",
	"category.select": "Select",
	"action.vertex_snap_mode.rotate": "Rotate",
	"action.export_image": "Export Image",
	"action.export_image.desc": "Export your texture as an image file",
	"action.apply_mirror_modeling": "Apply Mirror Modeling",
	"action.apply_mirror_modeling.desc": "Apply Mirror Modeling to the selection. All selected elements will be copied and flipped across the X axis.",
	"action.create_collection": "Create Collection",
	"action.create_collection.desc": "Create a collection out of the outliner selection",
	"action.set_collection_content_to_selection": "Set Collection Content to Selected",
	"action.set_collection_content_to_selection.desc": "Set the selected groups and elements as the content of the collection",
	"action.add_to_collection": "Add Selected to Collection",
	"action.add_to_collection.desc": "Add the selected groups and elements to the collection",
	"action.view_mode.material": "Material Preview",
	"action.create_material": "Create Material",
	"action.create_material.desc": "Create a new PBR material out of the selected texture",
	"action.generate_pbr_map": "Generate PBR Map...",
	"action.generate_pbr_map.desc": "Generate a PBR map (height map or metalness, emissiveness, roughness) from an existing texture",
	"menu.tools.main_tools": "Toolbox",
	"menu.view.panels": "Panels",
	"menu.texture.pbr_channel": "PBR Channel",
	"menu.texture.pbr_channel.color": "Color",
	"menu.texture.pbr_channel.normal": "Normal",
	"menu.texture.pbr_channel.height": "Height",
	"menu.texture.pbr_channel.mer": "MER (Metalness-Emissive-Roughness)",
	"menu.texture.pbr_channel.mer_subsurface": "MER Subsurface",
	"menu.collection.export_project": "Export Project",
	"menu.collection.export_as": "Export as \"%0\"",
	"menu.panel.enable": "Enable",
	"menu.panel.move_to": "Move To",
	"menu.panel.move_to.left_bar": "Left Sidebar",
	"menu.panel.move_to.right_bar": "Right Sidebar",
	"menu.panel.move_to.top": "Top",
	"menu.panel.move_to.bottom": "Bottom",
	"menu.panel.move_to.float": "Float",
	"menu.panel.move_to.hidden": "Hide",
	"menu.panel.fold": "Collapse",
	"menu.mirror_painting.texture_center": "Origin",
	"menu.mirror_modeling.mirror_uv": "Mirror UV",
	"menu.animation_onion_skin.frames": "Frames",
	"menu.animation_onion_skin.select": "Select",
	"menu.animation_onion_skin.previous": "Previous",
	"menu.animation_onion_skin.next": "Next",
	"menu.animation_onion_skin.previous_next": "Previous + Next",
	"menu.animation_onion_skin.count": "Count",
	"menu.animation_onion_skin.interval": "Interval",
	"menu.animation_onion_skin_selective": "Selective Onion Skin",
	"menu.animation_onion_skin_selective.desc": "Only display onion skin for the selected part of the model",
	"edit.loop_cut.unit": "Unit",
	"edit.loop_cut.unit.size_units": "Size Units",
	"edit.loop_cut.unit.percent": "Percent",
	"edit.extrude_mesh_selection.direction": "Direction",
	"edit.extrude_mesh_selection.direction.outwards": "Outwards",
	"edit.extrude_mesh_selection.direction.average": "Average",
	"edit.extrude_mesh_selection.even_extend": "Even Extend",
	"edit.vertex_snap.align": "Align",
	"edit.vertex_snap.align.longest": "Longest Axis",
	"edit.vertex_snap.align.direction": "Direction from Pivot",
	"edit.vertex_snap.align.align_axis": "%0 Axis",
	"edit.vertex_snap.ignore_axis": "Ignore Axis",
	"codec.common.format": "Format",
	"codec.image.quality": "Quality",
	"panel.collections": "Collections",
	"modifier_actions.always": "Always Enabled",
	"modifier_actions.unless": "Unless %0",
	"settings.undo_selections": "Undo Selection",
	"settings.undo_selections.desc": "Track selection changes as a step in the undo history",
	"action.focus_on_selection.zoom": "Zoom to fit",
	"display.reference.tooting": "Horn Tooting",
	"settings.selection_tolerance": "Selection Tolerance",
	"settings.selection_tolerance.desc": "Size of the area that can be clicked to select an edge or vertex",
	"action.delete.keep_vertices": "Keep Edges/Vertices",
	"menu.mesh": "Mesh",
	"dialog.material_config.subsurface": "Subsurface Scattering",
	"dialog.material_config.subsurface_enabled.desc": "Use the MER map alpha channel for subsurface scattering",
	"settings.pick_combined_color": "Pick Combined Color",
	"settings.pick_combined_color.desc": "Pick the combined color of all layers at the respective pixel, instead of the color on the active layer",
	"action.split_rgb_into_layers": "Split RGBA Channels into Layers",
	"action.split_rgb_into_layers.desc": "Split the texture into additive layers, one for each RGBA channel",
	"dialog.project.java_block_version": "Format Version",
	"data.spline_mesh": "Spline",
	"data.billboard": "Billboard",
	"data.armature": "Armature",
	"data.armature_bone": "Armature Bone",
	"generic.reload": "Reload",
	"modifier_actions.subtract": "Subtract",
	"modifier_actions.reduced_intensity": "Fine-Tune",
	"modifier_actions.select_bone": "Select Bone",
	"modifier_actions.spline_select_multiple_points": "Select multiple Points or Handles",
	"modifier_actions.move_panel_without_docking": "Move without docking",
	"message.save_all_textures.message": "Do you want to save each of the following textures?",
	"message.save_all_textures.skip": "Skip",
	"dialog.add_spline.shape": "Shape",
	"dialog.add_spline.shape.segment": "Segment",
	"dialog.add_spline.shape.square": "Rectangle",
	"dialog.add_spline.shape.circle": "Circle",
	"dialog.add_spline.diameter": "Diameter",
	"dialog.add_spline.sides_tubular": "Tube Segments",
	"dialog.add_spline.sides_radial": "Ring Segments",
	"dialog.add_spline.radius": "Tube Radius",
	"dialog.add_spline.length": "Length",
	"dialog.add_spline.width": "Width",
	"dialog.plugins.revoke_permissions": "Revoke Permissions",
	"dialog.expression_editor.pretty_print": "Pretty Print",
	"dialog.expression_editor.minify": "Minify",
	"dialog.expression_editor.find_replace": "Find/Replace",
	"dialog.create_gif.show_gizmos": "Record Gizmos & Grid",
	"dialog.preview_options.title": "Preview Options",
	"dialog.preview_options.background": "Background",
	"dialog.preview_options.background.checkerboard": "Checkerboard",
	"dialog.preview_options.background.solid": "Solid",
	"dialog.preview_options.background.custom_color": "Custom Color",
	"dialog.preview_options.show_gizmos": "Show Gizmos",
	"dialog.skin.texture_source": "Texture Source",
	"dialog.skin.texture_source.template": "Generate Template",
	"dialog.skin.texture_source.load_texture": "Load from Minecraft",
	"dialog.skin.texture_file": "Texture File",
	"dialog.convert_skin.adjust_texture": "Adjust Texture",
	"dialog.settings.clear_profile_value": "Clear profile value",
	"layout.section.customize": "Customize",
	"layout.theme.configure": "Configure",
	"layout.color.elevated": "Elevated",
	"layout.color.elevated.desc": "Elevated UI elements, usually separated by drop shadow",
	"layout.file.watch_changes": "Watch Changes and Reload",
	"settings.autocomplete_code": "Autocomplete Code",
	"settings.autocomplete_code.desc": "Display autocomplete suggestions in code editors",
	"settings.detect_flipbook_textures": "Detect Flipbook Textures",
	"settings.detect_flipbook_textures.desc": "Automatically detect flipbook animated textures and preview them as animation",
	"settings.double_click_select_reference": "Select Reference Image on Double Click",
	"settings.double_click_select_reference.desc": "Double click the viewport to select a reference image",
	"settings.default_keyframe_interpolation": "Default Keyframe Interpolation",
	"settings.default_keyframe_interpolation.desc": "Select the default keyframe interpolation mode",
	"settings.color_picker_style": "Color Picker Style",
	"settings.color_picker_style.desc": "Select the style of the paint mode color picker",
	"settings.export_asset_paths": "Export Asset Paths",
	"settings.export_asset_paths.desc": "Select how paths to assets such as textures or animations get saved in .bbmodel files",
	"settings.export_asset_paths.relative": "Relative Paths",
	"settings.export_asset_paths.absolute": "Full Paths",
	"settings.export_asset_paths.both": "Relative & Full Paths (Texture only)",
	"settings.export_asset_paths.none": "No Export",
	"action.slider_spline_resolution": "Spline Resolution %0",
	"action.slider_spline_resolution.desc": "Change spline resolution on the %0 axis (%1)",
	"action.slider_spline_resolution.u.desc_precision": "Ring Segments",
	"action.slider_spline_resolution.v.desc_precision": "Tube Segments",
	"action.slider_spline_radius": "Spline Radius",
	"action.slider_spline_radius.desc": "Change spline Radius",
	"action.slider_spline_handle_tilt": "Handle Tilt",
	"action.slider_spline_handle_tilt.desc": "Change spline handle Tilt",
	"action.slider_spline_handle_size": "Handle Size",
	"action.slider_spline_handle_size.desc": "Change spline handle Size",
	"action.blend_mode.lighten": "Lighten",
	"action.blend_mode.darken": "Darken",
	"action.weight_brush": "Weight Brush",
	"action.weight_brush.desc": "Paint vertex weights on meshes for armature deformations",
	"action.convert_minecraft_skin_variant": "Convert Slim/Wide Skin",
	"action.convert_minecraft_skin_variant.desc": "Switch the skin model between the classic wide (steve) model and the slim (alex) model. Optionally auto-adjust the texture to fit the model",
	"action.custom_skin_poses": "Custom Skin Poses",
	"action.custom_skin_poses.desc": "Load a custom skin pose preset",
	"action.custom_skin_poses.update": "Update Pose",
	"action.custom_skin_poses.update.desc": "Overwrite the saved pose with the current pose of the model",
	"action.add_custom_skin_pose": "Add Custom Skin Pose",
	"action.add_custom_skin_pose.desc": "Save the current pose of the model as a pose preset",
	"action.export_stl": "Export STL",
	"action.export_stl.desc": "Export a STL model for 3D printing",
	"action.add_element": "Add Element",
	"action.add_element.desc": "Add a new element from the list of element types",
	"action.add_spline": "Add Spline",
	"action.add_spline.desc": "Adds a new spline",
	"action.add_billboard": "Add Billboard",
	"action.add_billboard.desc": "Adds a new billboard, a flat element that always faces towards the camera",
	"action.add_armature": "Add Armature",
	"action.add_armature.desc": "Adds an armature that allows deforming a mesh via animation",
	"action.add_armature_bone": "Add Armature Bone",
	"action.add_armature_bone.desc": "Adds a bone to the armature",
	"action.search_textures": "Search Textures",
	"action.search_textures.desc": "Search for textures by name",
	"action.search_animations": "Search Animations",
	"action.search_animations.desc": "Search for animations by name",
	"action.spline_selection_mode": "Spline Selection Mode",
	"action.spline_selection_mode.object": "Object",
	"action.spline_selection_mode.handles": "Handles",
	"action.spline_render_mode": "Geometry",
	"action.spline_render_mode.mesh": "Mesh",
	"action.spline_render_mode.path": "Path",
	"action.spline_render_mode.desc": "Which geometry this spline should render",
	"action.spline_uv_mode": "UV Style",
	"action.spline_uv_mode.length_accurate": "Length Accurate",
	"action.spline_uv_mode.uniform": "Uniform",
	"action.spline_uv_mode.per_segment": "Per Segment",
	"action.spline_uv_mode.desc": "How the spline's tube mesh should lay its UVs",
	"action.spline_ring_segments": "Ring Segments",
	"action.spline_ring_segments.desc": "How many subdivisions this Spline has per Tube Ring",
	"action.spline_tube_segments": "Tube Segments",
	"action.spline_tube_segments.desc": "How many subdivisions this Spline has along its path",
	"action.spline_tube_radius": "Tube Radius",
	"action.spline_tube_radius.desc": "Set the Spline's Tube Radius",
	"action.spline_display_space": "Display Space",
	"action.spline_display_space.desc": "Display spline space indicators on its path",
	"action.spline_handle_mode": "Spline Handle Mode",
	"action.spline_handle_mode.desc": "Which mode to use for transforming spline handles",
	"action.spline_handle_mode.aligned": "Aligned",
	"action.spline_handle_mode.free": "Free",
	"action.spline_handle_mode.mirrored": "Mirrored",
	"action.slider_weight_brush_size": "Weight Brush Size",
	"action.weight_brush_xray": "Weight Brush XRay Mode",
	"action.weight_brush_xray.desc": "When enabled, the weight brush will affect all vertices instead of just the ones that are visible on the surface",
	"action.apply_spline_rotation": "Apply Rotation",
	"action.apply_spline_rotation.desc": "Reset the element rotation of the spline, and apply it to the geometry instead",
	"action.extrude_spline_selection": "Extrude Spline",
	"action.extrude_spline_selection.desc": "Extrude the selected handle on all splines",
	"action.split_spline": "Split Spline",
	"action.split_spline.desc": "Splits the spline into two splines at the selected handle",
	"action.divide_spline_curve": "Divide Spline Segment",
	"action.divide_spline_curve.desc": "Splits the spline segment into two new segments with a new handle at their intersection",
	"action.set_vertex_weights": "Set Vertex Weights",
	"action.set_vertex_weights.desc": "Set the vertex weights of the selected vertices to a specific value on a certain armature bone",
	"action.calculate_vertex_weights": "Calculate Vertex Weights",
	"action.calculate_vertex_weights.desc": "Automatically assign vertex weights weights based on the position of the bones",
	"action.shelf_alignment": "Shelf Alignment",
	"action.shelf_alignment.desc": "Select the vertical alignment of items on the shelf",
	"action.shelf_alignment.top": "Top Alignment",
	"action.shelf_alignment.bottom": "Bottom Alignment",
	"action.view_mode.vertex_weight": "Vertex Weight",
	"action.view_mode.weighted_bone_colors": "Vertex Bone Colors",
	"action.create_animation_group": "Create Animation Group",
	"action.create_animation_group.desc": "Create a group of animations",
	"action.move_graph_keyframes_up": "Move Keyframe Graph Up",
	"action.move_graph_keyframes_down": "Move Keyframe Graph Down",
	"menu.skin": "Skin",
	"menu.text_edit.expression_editor": "Expression Editor",
	"menu.color_picker.picker_type.normal": "Normal Map",
	"menu.texture.flipbook_animation": "Flipbook Animation",
	"menu.panel.attach_to": "Attach To",
	"menu.animation.playing": "Playing",
	"menu.animation_file.save_as": "Save As",
	"menu.animator.quaternion_interpolation": "Quaternion Interpolation",
	"edit.extrude_spline_selection.extend": "Extend",
	"edit.divide_spline_curve.position": "Position",
	"group.bedrock_binding": "Binding",
	"group.cem_attach": "CEM Attach",
	"group.cem_model": "CEM Model",
	"group.cem_scale": "CEM Scale",
	"cube.rescale": "Rotation Rescale",
	"cube.rescale.desc": "Rescale cube to compensate for the rotation angle",
	"mesh.shading": "Shading",
	"mesh.shading.flat": "Flat",
	"mesh.shading.smooth": "Smooth",
	"spline_mesh.cyclic": "Cyclic",
	"spline_mesh.cyclic.desc": "Whether the selected spline should form a loop (Cycle)",
	"billboard.offset": "Offset",
	"billboard.facing_mode": "Facing Mode",
	"billboard.facing_mode.lookat": "Look At",
	"billboard.facing_mode.lookat_y": "Look At Y",
	"billboard.facing_mode.rotate": "Rotate",
	"billboard.facing_mode.rotate_y": "Rotate Y",
	"armature_bone.connected": "Connected",
	"reference_image.blueprint": "Locked Blueprint",
	"codec.image.alpha_channel": "Alpha Channel",
	"codec.image.animation_fps": "Animation FPS",
	"panel.palette": "Palette",
	"panel.keyframe.change_effect_file": "Change Effect File",
	"panel.transform": "Transform",
	"panel.element.spline_dimensions": "Spline Dimensions",
	"display.slot.on_shelf": "Shelf",
	"display.reference.shelf": "Shelf (All Slots)",
	"display.reference.shelf_left": "Shelf (Left Slot)",
	"display.reference.shelf_center": "Shelf (Center Slot)",
	"display.reference.shelf_right": "Shelf (Right Slot)",
	"message.newer_project_format_version.title": "Outdated client",
	"message.newer_project_format_version.message": "This file was saved in a newer version of Blockbench. Update to Blockbench %0 or newer to be able to open it correctly",
	"message.load_images.add_layer": "Add as Layer",
	"message.load_images.category.add_to_project": "Add to project",
	"message.load_images.category.new_project": "New project",
	"message.load_palette.title": "Load Palette",
	"message.load_palette.message": "Are you sure you want to load this palette? This will replace your current color palette.",
	"dialog.set_vertex_weights.weight": "Weight",
	"dialog.set_vertex_weights.overwrite": "Overwrite other bones",
	"action.element_render_order.short": "Render Order",
	"action.element_render_order.desc": "Render order of elements. This can help fix elements that are hidden behind other elements with transparent textures. Leave it on Auto for opaque elements.",
	"spline.shading.flat": "Flat",
	"spline.shading.smooth": "Smooth",
	"spline.shading": "Shading",
	"spline.shading.desc": "How this spline's tube should be shaded",
	"action.slider_weight_brush_limit": "Weight Brush Limit",
	"action.slider_weight_brush_limit.desc": "Set an upper limit for how much weight the weight brush can assign to a vertex",
	"action.weight_brush_blend_mode": "Weight Brush Blend Mode",
	"action.weight_brush_blend_mode.set": "Set",
	"action.weight_brush_blend_mode.add": "Add",
	"action.apply_texture_to_elements": "Apply Texture to Elements",
	"action.apply_texture_to_elements.desc": "Apply the selected texture to the selected elements",
	"menu.panel.reset_size": "Reset Size",
	"action.import_layer": "Import Layer",
	"action.import_layer.desc": "Import image files as layers",
	"menu.collection.open_file": "Open File",
	"layout.version": "Version",
	"settings.status_bar_transform_sliders": "Transform Sliders in Status Bar",
	"settings.status_bar_transform_sliders.desc": "Display the transform sliders toolbar of the selected tool in the status bar instead of using the Transform panel",
	"settings.default_bedrock_format": "Default Bedrock Format",
	"settings.default_bedrock_format.desc": "Select the default format to load Minecraft Bedrock models in, when no specific format can be detected from context.",
	"settings.limit_brush_opacity_per_stroke": "Limit Brush Opacity per Stroke",
	"settings.limit_brush_opacity_per_stroke.desc": "Limit the opacity that a brush can apply to the value of the opacity slider during each brush stroke. With a smooth brush this behavior can potentially lead to slight unwanted noise.",
	"action.merge_splines": "Merge Splines",
	"action.merge_splines.desc": "Merge multiple splines into one",
	"settings.default_java_block_version": "Default Java Block/Item Version",
	"settings.default_java_block_version.desc": "Default format version when creating new Java block/item models or opening files without format version",
	"data.bounding_box": "Bounding Box",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "Left-click slide horizontal",
	"keys.slide_lmb_vertical": "Left-click slide vertical",
	"keys.slide_rmb_horizontal": "Right-click slide horizontal",
	"keys.slide_rmb_vertical": "Right-click slide vertical",
	"message.recover_backup.unknown_project": "Unknown project",
	"message.recover_backup.discard_others": "Discard all others",
	"message.unsupported_file_extension.title": "File format not supported",
	"message.unsupported_file_extension.message": "Cannot open file %0, the format is not supported. You might need a plugin for this file type.",
	"message.unsupported_file_extension.open_in_default_program": "Open in default program",
	"dialog.project.uv_size": "UV Size",
	"dialog.collection.offset": "Offset",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Frames per second of the texture flipbook animation",
	"dialog.edit_uv_size.title": "Edit UV Size",
	"dialog.edit_uv_size.target": "Target",
	"dialog.edit_uv_size.adjust": "Adjust",
	"dialog.edit_uv_size.adjust.adjust_uv": "Counter UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "Counter UV & Scale",
	"dialog.edit_uv_size.adjust.keep": "Keep UV",
	"dialog.edit_uv_size.target_size": "Target UV Size",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Match Texture",
	"dialog.edit_uv_size.result": "Result",
	"dialog.edit_uv_size.result.textures": "Textures",
	"dialog.adjust_brightness_contrast.brightness": "Brightness",
	"dialog.adjust_brightness_contrast.contrast": "Contrast",
	"dialog.adjust_saturation_hue.saturation": "Saturation",
	"dialog.adjust_saturation_hue.hue": "Hue",
	"dialog.adjust_opacity.mode": "Mode",
	"dialog.adjust_opacity.mode.multiply": "Multiply",
	"dialog.adjust_opacity.mode.set": "Set",
	"dialog.bedrock_bounding_box.type": "Type",
	"dialog.bedrock_bounding_box.type.collision_box": "Collision",
	"dialog.bedrock_bounding_box.type.selection_box": "Selection Box",
	"dialog.bedrock_bounding_box.type.hitbox": "Hitbox",
	"dialog.bedrock_bounding_box.hitbox_note": "Please note that entity hitboxes only work up to a certain size and may not adapt to the rotation of the entity in-game.",
	"dialog.bedrock_bounding_box.collision_note": "Please note that entity collision boxes only support one centered shape with a square top profile.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "No bounding boxes exist in this project",
	"dialog.install_plugins_from_list.ids": "Plugin IDs",
	"dialog.install_plugins_from_list.info": "Install several plugins from a list of IDs. Before installing, please ensure that you actually need all plugins. Keeping inactive plugins can increase the risk of bugs and incompatibilities with future updates.",
	"dialog.copy_installed_plugins.details": "Include Details",
	"dialog.flip_animation.phase_offset": "Phase Offset",
	"dialog.flip_animation.phase_offset.off": "Off",
	"dialog.flip_animation.phase_offset.custom": "Custom",
	"dialog.flip_animation.clear_opposite": "Overwrite opposite",
	"settings.flipbook_textures_in_animation": "Play Flipbook Textures in Animation",
	"settings.flipbook_textures_in_animation.desc": "Preview animations on flipbook textures in sync with the animation timeline",
	"settings.display_uv": "Display UV Faces",
	"settings.display_uv.desc": "Select which UV faces are displayed in the UV editor",
	"settings.display_uv.selected_faces": "Only selected faces",
	"settings.display_uv.selected_elements": "All faces on selected elements",
	"settings.display_uv.all_elements": "All faces on all elements",
	"settings.local_position_values": "Local Position Values",
	"settings.local_position_values.desc": "Display all position values in the Transform panel in local space",
	"settings.transform_cube_from_center": "Transform Cubes from Center",
	"settings.transform_cube_from_center.desc": "Edit the cube position values from the center instead of the corner",
	"settings.color_picker_tool_switch": "Color Picker Tool Switch",
	"settings.color_picker_tool_switch.desc": "When picking a transparent pixel, switch to the eraser. When the eraser was previously selected and a color is picked, switch to the brush",
	"keybind.preview_scroll_zoom": "Zoom View",
	"keybind.uv_editor_scroll_zoom": "Zoom UV/2D Editor",
	"action.blend_mode.alpha_mask": "Alpha Mask",
	"action.swap_tools.hold": "Hold to swap (Color Picker)",
	"action.import_bedrock_voxel_shape": "Import Bedrock Voxel Shape",
	"action.import_bedrock_voxel_shape.desc": "Add a voxel shape from a json file to the current project",
	"action.export_bedrock_voxel_shape": "Export Bedrock Voxel Shape",
	"action.export_bedrock_voxel_shape.desc": "Export the bounding boxes in the project as a bedrock voxel shape file",
	"action.plugins_window_menu": "Menu",
	"action.copy_installed_plugins": "Copy Installed Plugins",
	"action.copy_installed_plugins.desc": "Generate and copy a list of the currently installed plugins",
	"action.install_plugins_from_list": "Install Plugins from List",
	"action.install_plugins_from_list.desc": "Install plugins from a list of plugin IDs",
	"action.add_bounding_box": "Add Bounding Box",
	"action.add_bounding_box.desc": "Adds a new bounding box",
	"action.split_alpha_into_layer": "Split Alpha Channel into Layer",
	"action.split_alpha_into_layer.desc": "Split the alpha channel of the texture into an alpha mask layer",
	"action.generate_bedrock_block_box": "Copy Collision/Selection Component",
	"action.generate_bedrock_block_box.desc": "Generate a collision or selection box component for Minecraft Bedrock Edition blocks",
	"action.generate_bedrock_entity_box": "Copy Collision/Hitbox Component",
	"action.generate_bedrock_entity_box.desc": "Generate a collision or custom hit test component for Minecraft Bedrock Edition entities",
	"action.refresh_texture": "Refresh Texture",
	"action.refresh_texture.desc": "Reload the texture from file",
	"action.move_uv_to_cursor": "Move UV to Cursor",
	"action.move_uv_to_cursor.desc": "Move the selected UV faces to the mouse cursor position",
	"action.edit_mode_uv_overlay": "Display All Elements",
	"action.round_keyframe_values": "Round Keyframe Values",
	"action.round_keyframe_values.desc": "Round all values of the selected keyframes",
	"action.keyframe_column_create.all_channels": "All Channels",
	"action.keyframe_column_create.all_channels.desc": "Initialize all channels with keyframes even if they had no keyframes previously",
	"action.add_all_to_timeline": "Add All to Timeline",
	"action.mirror_animating": "Mirror Animating",
	"action.mirror_animating.desc": "Mirror animation edits to the opposite side",
	"action.copy_animation_pose": "Copy Animation Pose",
	"action.copy_animation_pose.desc": "Copy all keyframes to replicate the current animation pose",
	"menu.texture.file_format": "File Format",
	"menu.texture.wrap_mode": "Wrap Mode",
	"menu.texture.wrap_mode.limited": "Restricted",
	"menu.texture.wrap_mode.repeat": "Repeat",
	"menu.texture.wrap_mode.clamp": "Clamp Edge",
	"edit.reparent_selection.adjust_position": "Preserve World Transform",
	"texture_mesh.texture_name": "Texture Name",
	"display.slot.embedded": "Embedded",
	"display.animate_preview": "Preview Animation",
	"display.reference.flower_pot": "Flower Pot"
}